/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable operator-linebreak */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable no-nested-ternary */
import * as Yup from 'yup';
import { OBLIGATION_REGEX, CONTACT_NUMBER_REGEX, NAME_FIELDS_NEW_REGEX, NAME_FIELDS_REGEX, ORGANISATION_NAME_REGEX, FIELDS_WITH_SEPCIFI_CHARS, VEHICLE_REGISTRATION_REGEX, FREE_TEXT_FIELD_REGEX } from '@services/ValidationRules';
import { iFVSAddress, iContact, iFormMetaData, iAttachments, iFVSCheckboxAll, iObligation, iValue, iSummary, iSummaryField } from '@interfaces/interfaces';
import { ProgressStep, FormType } from '@constants';
import { reverseTrueOrFalseSubmission } from '@utils';
import { FormikValues, getIn } from 'formik';
import { fvsInfoDisplayObject } from '@services/FormFieldConfig';

import {
  INVALID_OBLIGATION_NUMBER,
  INVALID_NUMERIC_FORMAT,
  INVALID_YESNO_FORMAT,
  INVALID_NAME_FORMAT,
  EMPTY_DATE,
  EMPTY_CHECKBOX,
  INVALID_FUTURE_DATE,
  INVALID_PHONE_NUMBER_LENGTH,
  INVALID_PHONE_NUMBER,
  INVALID_VEHICLE_REGISTRATION_NUMBER,
  INVALID_EMAIL,
  MISSING_DECLARATION_AGREEMENT,
  INVALID_FILE_SIZE,
  INVALID_FILE_TYPE,
  FILE_UPLOAD_FAIL,
  INVALID_LICENCE_FORMAT,
  MISSING_APPLICATION_LODGING_AGREEMENT,
  INVALID_MOBILE_NUMBER_FORMAT,
  FIELDS_WITH_SEPCIFI_CHARS_MSG,
  INVALID_ORG_NAME_FORMAT,
  INVALID_FREE_TEXT_FIELD_FORMAT,
  INVALID_PHONE_NUMBER_LENGTH_15
} from './ErrorMessages';
import keys from './PageValidationKeys';

const joinAddressFields = (entry: string[]) => {
  if (entry[0] === 'Address' || entry[0] === 'SearchText') return null;
  if (entry[0] === 'Country') return entry[1];
  return entry[1];
};

const displayFileDetails = (attachment: iAttachments) => {
  if (attachment.FileName !== '' && attachment.FileDescription !== '') {
    return `${attachment.FileName} : ${attachment.FileDescription}`;
  }
  if (attachment.FileName !== '' && attachment.FileDescription === '') {
    return `${attachment.FileName}`;
  }
  return '';
};
const { riskAndSupportDetails, backgroundAndIdentityDetails, likelyPossibilities, paymentArrangements } = fvsInfoDisplayObject.pages;
const listUnregisteredFines = (values: iFVSFormValues, unregisteredFinesArray: iValue[]) =>
  unregisteredFinesArray.map(
    (fine, index) =>
      `Enforcement agency: ${getIn(values, `AgencyNames.${index}.value`) ? getIn(values, `AgencyNames.${index}.value`) : 'n/a'}, Infringement notice number: ${
        getIn(values, `InfringementNums.${index}.value`) ? getIn(values, `InfringementNums.${index}.value`) : 'n/a'
      }, Alleged offence: ${getIn(values, `AOffence.${index}.value`) ? getIn(values, `AOffence.${index}.value`) : 'n/a'}, Date of alleged offence: ${
        getIn(values, `DAOffence.${index}.value`) ? new Date(getIn(values, `DAOffence.${index}.value`)).toLocaleDateString('en-AU', { timeZone: 'Australia/Melbourne' }) : 'n/a'
      }`,
  );
export interface iPartialFormData {
  a: string;
  // is submitted
  submitted: boolean;
  // FVS Step1 Field
  OBLIGATION_NUMBER: string;
  // FVS Step2 Fields
  OFFENCE_DATE: Date | null;
  HEARING_DATE: Date | null;
  VEHICLE_REGISTRATION: string;
  DRIVER_LICENCE: string;

  // FVS step 4 fields
  SaveYesNo: string;
  SaveOptions: string;
  saveEmail: string;
  saveMobile: string;
  // step 5
  ApplicationLodger: string;
  ConsentToThirdParty: boolean;

  // FVS step 3 fields
  // Has7DayNotice: string | null;
  ActionsTakenOnFine: string[];
  NoActionsTaken: boolean;
  HasLinkBwFVSAndFines: string | null;
  HasEvidenceToSupport: string | null;
  isUrgent: boolean;
  // FVS step 6 fields
  GivenNames: string;
  FamilyName: string;
  DOB: Date | null;
  StatecountryOfIssue: string;
  LicenceState: string;
  NoDriverLicence: boolean;
  FVSResidentialAddress: iFVSAddress;
  NoResidentialAddress: boolean;
  DeliveryAddressType: string;
  FVSPostalAddress: iFVSAddress;
  NoSafePostalAddress: boolean;
  IsEmailRequired: string | null;
  Email: string;
  NoEmail: boolean;
  SendEmailCopy: string | null;
  PhoneApplicant: string | null;
  IndividualContactNumber: iContact;
  EmailWarning: string;
  IndividualContactNumberWarning: string;
  SafestContactTime: string;
  PhoneMessagePrompt: string | null;
  InterpreterRequiredPrompt: string | null;
  AlternativeLanguage: string;
  NoFixedAddress: string;
  // FVS Step 7 and 16 fields
  HasScaredFeelings: string | null;
  HasRiskAssessment: string | null;
  ContactSpecialist: string | null;
  // FVS Step 8 and 17 fields
  Gender: string;
  GenderSelfDescribed: string;
  LGBTIQIdentified: string | null;
  Origin: string;
  EnglishProficiency: string;
  NativeLanguage: string;
  HasDisability: string | null;
  DisabilityDescription: string;
  // FVS Step 9
  InfringementNoticeNumber: string;
  SelectedObligationsStep9: iFVSCheckboxAll[];
  ObligationStatus: string;
  TicketType: string;
  Status: string;
  OffenceCode: string;
  relevantObs: iObligation[];
  WhichOtherFines: string | null;
  enteredObligationsArray: iValue[];
  AdditionalFinesToInclude: string;
  InfringementNums: iValue[];
  AgencyNames: iValue[];
  AOffence: iValue[];
  DAOffence: iValue[];
  // FVS Step 10 and 20 fields
  WhatWouldYouLikeToHappen: string | null;
  FamilyNameOptional: string;
  GivenNamesOptional: string;
  DOBOptional: Date | null;
  DriverLicenceNumberOptional: string;
  StatecountryOfIssueOptional: string;
  LicenceStateOptional: string;
  NoDriverLicenceOptional: boolean;
  HowDealtWithFines: string;
  // FVS Step 11 and 21 fields
  HasPaymentArrangement: string | null;
  RemoveFines: string | null;
  ReincludeFines: string | null;
  // FVS Step 12
  SupportingAttachments: iAttachments[];
  UnableToObtainAdoc: boolean;
  SignedDeclarationAttachment: iAttachments[];
  // FVS Step 13
  OtherSupportingAttachments: iAttachments[];
  ReasonForApplication: string;
  // FVS Step 14
  RepresentativeGivenName: string;
  RepresentativeFamilyName: string;
  RepresentativeRelationshipToVictim: string;
  RepresentativeCompanyName: string;
  RepresentativeCompanyPosition: string;
  RepresentativePostalAddress: iFVSAddress;
  RepresentativeEmailAddress: string;
  RepresentativeRequestsEmailCopyBool: string;
  FVSContactNumber: iContact;
  FVSContactNumberWarning: string;
  RepresentativeEmailAddressWarning: string;
  RepresentativeAllowsPhoneCommunicationBool: string;
  RepresentativePreferredContactDayTime: string;

  // FVS Step 18
  obligations: iValue[];
  RegisteredFinesToInclude: string;
  InfringementFinesToInclude: string;
  AdditionalFinesType: string;
}

interface iPartialFormObligations {
  ID: number;
  ObligationNO: string;
  IsPrimary: boolean;
}
export interface iCommonFVSFormValues {
  [key: string]:
    | string
    | number
    | boolean
    | iPartialFormObligations[]
    | iObligation
    | iPartialFormData
    | iObligation[]
    | iAttachments[]
    | iValue[]
    | iFVSCheckboxAll[]
    | string[]
    | Date
    | null
    | iFVSAddress
    | iContact;
  // is submitted
  submitted: boolean;
  // FVS Step1 Field
  OBLIGATION_NUMBER: string;
  // FVS Step2 Fields
  OFFENCE_DATE: Date | null;
  HEARING_DATE: Date | null;
  VEHICLE_REGISTRATION: string;
  // Step 2 and 6
  DRIVER_LICENCE: string;
  DOB: Date | null;
  // FVS step 3 fields
 //  Has7DayNotice: string | null;
  ActionsTakenOnFine: string[];
  NoActionsTaken: boolean;
  HasLinkBwFVSAndFines: string | null;
  HasEvidenceToSupport: string | null;
  isUrgent: boolean;
  // FVS step 4 fields
  SaveYesNo: string;
  SaveOptions: string;
  saveEmail: string;
  saveMobile: string;
  // FVS partial form ID
  ID: string;
  PartialFormID: string;
  FormData: iPartialFormData;
  Obligations: iPartialFormObligations[];
}

export interface iFVSFormValues extends iCommonFVSFormValues {
  // FVS Step4 response
  InfringementNoticeNumber: string;
  Attachments: string[];
  DebtorID: number;
  FormTypeID: number;
  IsSubscribedEM: boolean;
  IsSubscribedSMS: boolean;
  EMRemeinderSent: boolean;
  SMSRemeinderSent: boolean;
  CreateDate: string;
  ExpiryDate: string;
  // GetObligationOptions response
  DebtorType: string;
  // CreateReceiptNumber response
  submissionNo: string;
  // Declaration
  declaration: boolean;
  // FVS Step5 Fields
  ApplicationLodger: string;
  ConsentToThirdParty: boolean;
  // FVS step 6 fields
  GivenNames: string;
  FamilyName: string;
  StatecountryOfIssue: string;
  LicenceState: string;
  NoDriverLicence: boolean;
  FVSResidentialAddress: iFVSAddress;
  NoResidentialAddress: boolean;
  DeliveryAddressType: string;
  FVSPostalAddress: iFVSAddress;
  NoSafePostalAddress: boolean;
  IsEmailRequired: string | null;
  Email: string;
  NoEmail: boolean;
  SendEmailCopy: string | null;
  PhoneApplicant: string | null;
  IndividualContactNumber: iContact;
  EmailWarning: string;
  IndividualContactNumberWarning: string;
  SafestContactTime: string;
  PhoneMessagePrompt: string | null;
  InterpreterRequiredPrompt: string | null;
  AlternativeLanguage: string;
  // FVS Step 7 and 16 fields
  HasScaredFeelings: string | null;
  HasRiskAssessment: string | null;
  ContactSpecialist: string | null;
  // FVS Step 8 and 17 fields
  Gender: string;
  GenderSelfDescribed: string;
  LGBTIQIdentified: string | null;
  Origin: string;
  EnglishProficiency: string;
  NativeLanguage: string;
  HasDisability: string | null;
  DisabilityDescription: string;
  // FVS Step 9 and 18 fields
  SelectedObligationsStep9: iFVSCheckboxAll[];
  SelectedObNums: string;
  AuthorisedObligation: iObligation;
  EligibleObligations: iObligation[];
  ObligationStatus: string;
  AdditionalFinesToInclude: string;
  relevantObs: iObligation[];
  WhichOtherFines: string | null;
  TicketType: string;
  Status: string;
  OffenceCode: string;
  enteredObligationsArray: iValue[];
  obligations: iValue[];
  infringementFineArray: iValue[];
  InfringementNums: iValue[];
  AgencyNames: iValue[];
  AOffence: iValue[];
  DAOffence: iValue[];
  SelectedObligations: string[];
  InfringementFinesToInclude: string;
  RegisteredFinesToInclude: string;
  AdditionalFinesType: string;
  AnyEligibleNomiation: boolean;
  // FVS Step 10 and 19 fields
  WhatWouldYouLikeToHappen: string | null;
  FamilyNameOptional: string;
  GivenNamesOptional: string;
  DOBOptional: Date | null;
  DriverLicenceNumberOptional: string;
  StatecountryOfIssueOptional: string;
  LicenceStateOptional: string;
  NoDriverLicenceOptional: boolean;
  HowDealtWithFines: string;
  AnyPaymentArrangement: boolean;
  // FVS Step 11 and 20 fields
  HasPaymentArrangement: string | null;
  RemoveFines: string | null;
  ReincludeFines: string | null;
  // FVS Step 12 and 21 fields
  SupportingAttachments: iAttachments[];
  SupportingFilesProvider: string;
  SupportingFilesDescription: string;
  ReportNameField: string;
  ReportNameFieldErrorHandle: boolean;
  ReportUploadFileSectionError: string;
  UnableToObtainAdoc: boolean;
  StatutoryUploadFileSectionError: string;
  SignedDeclarationAttachment: iAttachments[];
  SignedStatutoryProvider: string;
  SignedStatutoryDescription: string;
  SignedDeclarationNameField: string;
  SignedStatutoryFieldErrorHandle: boolean;
  // FVS Step 13 and 22 fields
  OtherSupportingDocNameField: string;
  OtherSupportingAttachments: iAttachments[];
  OtherSupportingFilesProvider: string;
  OtherSupportingFilesDescription: string;
  OtherReportNameFieldErrorHandle: boolean;
  ReasonForApplication: string;
  // FVS Step 14
  RepresentativeGivenName: string;
  RepresentativeFamilyName: string;
  RepresentativeRelationshipToVictim: string;
  RepresentativeCompanyName: string;
  RepresentativeCompanyPosition: string;
  RepresentativePostalAddress: iFVSAddress;
  RepresentativeEmailAddress: string;
  RepresentativeRequestsEmailCopyBool: string;
  FVSContactNumber: iContact;
  FVSContactNumberWarning: string;
  RepresentativeEmailAddressWarning: string;
  RepresentativeAllowsPhoneCommunicationBool: string;
  RepresentativePreferredContactDayTime: string;

  // File upload failed
  ReportNameFileUplodErrorHandle: boolean;
  SignedStatutoryFileUploadErrorHandle: boolean;
  OtherReportNameFileUploadErrorHandle: boolean;
  // submission error message
  submissionError: string;
}

export interface iSubmitFVSFormValues extends iCommonFVSFormValues {
  YourObligationNumber: string;
  OBLIGATION_NUMBER: string;
  IdentifyingReference: string;

  // step 3
  LinkYes: string;
  LinkNo: string;
  EvidenceYes: string;
  EvidenceNo: string;
  Sheriff7DayNoticeYes: string;
  Sheriff7DayNoticeNo: string;
  SheriffRemoveNumberplates: string;
  SheriffSeize: string;
  SheriffWheelClamp: string;
  LostLicence: string;
  AttachmentEarnings: string;
  LandCharge: string;
  NoneApply: string;
  // step 5
  PersonAffected: string;
  AuthorisedRep: string;
  // step 6
  FamilyName: string;
  GivenNames: string;
  DateOfBirth: string;
  DriverLicenceNumber: string;
  ResidentialState: string;
  ResidentialSuburb: string;
  ResidentialPostcode: string;
  ResidentialCountry: string;
  NoFixedAddress: string;
  PreferNotToProvide: string;
  ResidentialAddress: string;
  PostalAddress: string;
  AnotherPostal: string;
  PostalPostcode: string;
  PostalSuburb: string;
  PostalState: string;
  PostalCountry: string;
  SameAsResidential: string;
  NoSafePostal: string;
  SafeToEmailYes: string;
  SafeToEmailNo: string;
  EmailAddress: string;
  SafeToCallYes: string;
  SafeToCallNo: string;
  ContactPhone: string;
  SafestDaysTimes: string;
  LeavePhoneMessageYes: string;
  LeavePhoneMessageNo: string;
  InterpreterYes: string;
  InterpreterNo: string;
  Language: string;

  // Step 16
  RepGivenNames: string;
  RepFamilyName: string;
  RelationshipPersonAffected: string;
  OrganisationCompanyName: string;
  PostitionOrganisationCompany: string;
  RepPostalAddress: string;
  RepPostalState: string;
  RepPostalSuburb: string;
  RepPostalPostcode: string;
  RepPostalCountry: string;
  RepPhoneNumber: string;
  RepCanWeCallYes: string;
  RepCanWeCallNo: string;
  RepBestDaysTime: string; // RepBestDaysTime RiskAfraidNo
  RepEmailAddress: string;

  // step 7
  RiskAfraidYes: string;
  RiskAfraidNo: string;
  SupportAgencyAssessmentNo: string;
  SupportAgencyAssessmentYes: string;
  SupportAgencyAssessmentUnsure: string;
  SupportServicesContactNo: string;
  SupportServicesContactYes: string;

  // step 8
  GenderMale: string;
  GenderFemale: string;
  GenderSelfDescribedSpecify: string;
  LGBTIQYes: string;
  LGBTIQNo: string;
  DisabilityImpairmentYes: string;
  DisabilityImpairmentNo: string;
  DisabilityImpairmentSpecify: string;
  ATSIYes: string;
  ATSINo: string;
  EnglishNo: string;
  EnglishPoorly: string;
  EnglishAdequately: string;
  EnglishWell: string;
  HomeLanguage: string;

  // Step 9 third party
  ObligationsAllOutstanding: string;
  ObligationsListed: string;
  ObligationsListedExclude: string;

  ObligationNumbersIncludeExclude: string;
  // self EnforcementAgency #1 to #10 dynamically added those fields
  // Step 10
  HaveFinesWithdrawn: string;
  NominateDriver: string;
  DriverGivenNames: string;
  DriverFamilyName: string;
  DriverDriverStateCountryIssue: string;
  DriverDriverLicence: string;
  DriverDOB: string;
  StatecountryOfIssue: string;
  CombinationAbove: string;
  CombinationDescribe: string;
  // Step 11
  PAYes: string;
  PANo: string;
  PARemoveYes: string;
  PARemoveNo: string;
  PAProposeYes: string;
  PAProposeNo: string;
  // Step 12 Need calculated
  NumberAttachments: string;
  DocumentDescriptions: string;
  // Step 13
  ReasonsApplication: string;
  // Step 24 self
  ApplicantDeclaration: string;
  ApplicantDeclarationDate: string;
  // Step 24 third party
  RepDeclaration: string;
  RepDeclarationDate: string;

  // additonal ob pdf page

  OBLIGATIONS_TO_INCLUDE: string;

  // Extra information, not sure whether it's used
  ThirdParty: string; // not sure
  //
  FooterSubmissionNo1: string;
  FooterFormType1: string;
  FooterObligationNo1: string;
  FooterSubmittedTime1: string;

  FooterSubmissionNo2: string;
  FooterFormType2: string;
  FooterObligationNo2: string;
  FooterSubmittedTime2: string;

  FooterSubmissionNo3: string;
  FooterFormType3: string;
  FooterObligationNo3: string;
  FooterSubmittedTime3: string;

  FooterSubmissionNo4: string;
  FooterFormType4: string;
  FooterObligationNo4: string;
  FooterSubmittedTime4: string;

  FooterSubmissionNo5: string;
  FooterFormType5: string;
  FooterObligationNo5: string;
  FooterSubmittedTime5: string;

  FooterSubmissionNo6: string;
  FooterFormType6: string;
  FooterObligationNo6: string;
  FooterSubmittedTime6: string;

  FooterSubmissionNo7: string;
  FooterFormType7: string;
  FooterObligationNo7: string;
  FooterSubmittedTime7: string;
}

export const defaultForm = (): iFVSFormValues => {
  const defaultValues: iFVSFormValues = {
    // is submitted
    submitted: false,
    // iCommonValues
    PartialFormID: '',
    OBLIGATION_NUMBER: '',
    InfringementNoticeNumber: '',
    // FVS Step2 Fields
    OFFENCE_DATE: null,
    HEARING_DATE: null,
    DRIVER_LICENCE: '',
    VEHICLE_REGISTRATION: '',
    // FVS step 3 Fields
    // Has7DayNotice: null,
    ActionsTakenOnFine: [],
    NoActionsTaken: false,
    HasLinkBwFVSAndFines: null,
    HasEvidenceToSupport: null,
    isUrgent: false,
    // FVS step 4 fields
    SaveYesNo: '',
    SaveOptions: '',
    saveEmail: '',
    saveMobile: '',
    // FVS Step 5 Field
    ApplicationLodger: '',
    ConsentToThirdParty: false,
    // FVS Step 6 fields
    FamilyName: '',
    GivenNames: '',
    DOB: null,
    LicenceState: '',
    NoDriverLicence: false,
    StatecountryOfIssue: 'Australia',
    NoFixedAddress: '',
    NoResidentialAddress: false,
    FVSResidentialAddress: {
      SearchText: '',
      Address: '',
      LineTwo: '',
      LineOne: '',
      Suburb: '',
      State: '',
      Postcode: '',
      Country: 'Australia',
    },
    DeliveryAddressType: '',
    FVSPostalAddress: {
      SearchText: '',
      Address: '',
      LineTwo: '',
      LineOne: '',
      Suburb: '',
      State: '',
      Postcode: '',
      Country: 'Australia',
    },
    NoSafePostalAddress: false,
    Email: '',
    NoEmail: false,
    IsEmailRequired: null,
    SendEmailCopy: '',
    PhoneApplicant: '',
    IndividualContactNumber: {
      ContactNumber: '',
      NumberType: 'Mobile',
      SecondaryContactNumber: '',
      SecondaryNumberType: 'Mobile',
    },
    EmailWarning: '',
    IndividualContactNumberWarning: '',
    SafestContactTime: '',
    PhoneMessagePrompt: '',
    InterpreterRequiredPrompt: '',
    AlternativeLanguage: '',
    // FVS Step 7 fields
    HasScaredFeelings: null,
    HasRiskAssessment: null,
    ContactSpecialist: null,
    // FVS Step 8 fields
    Gender: '',
    GenderSelfDescribed: '',
    LGBTIQIdentified: null,
    Origin: '',
    EnglishProficiency: '',
    NativeLanguage: '',
    HasDisability: null,
    DisabilityDescription: '',
    // FVS Step 10 fields
    WhatWouldYouLikeToHappen: null,
    FamilyNameOptional: '',
    GivenNamesOptional: '',
    DOBOptional: null,
    DriverLicenceNumberOptional: '',
    LicenceStateOptional: '',
    NoDriverLicenceOptional: false,
    StatecountryOfIssueOptional: 'Australia',
    HowDealtWithFines: '',
    AnyPaymentArrangement: false,
    // FVS Step 11 fields
    HasPaymentArrangement: null,
    RemoveFines: null,
    ReincludeFines: null,
    // GetObligationOptions response
    DebtorType: '',
    Attachments: [],
    DebtorID: 0,
    FormTypeID: 0,
    EMAIL_TO: '',
    // CreateReceiptNumber response
    submissionNo: '',
    IsSubscribedEM: false,
    IsSubscribedSMS: false,
    EMRemeinderSent: false,
    SMSRemeinderSent: false,
    CreateDate: '',
    ExpiryDate: '',
    // FVS Step 9
    SelectedObligationsStep9: [],
    enteredObligationsArray: [{ value: '' }],
    obligations: [{ value: '' }],
    infringementFineArray: [{ value: '' }],
    ObligationStatus: '',
    TicketType: '',
    Status: '',
    OffenceCode: '',
    relevantObs: [],
    WhichOtherFines: null,
    AdditionalFinesToInclude: '',
    RegisteredFinesToInclude: '',
    AdditionalFinesType: '',
    InfringementFinesToInclude: '',
    InfringementNums: [{ value: '' }],
    AgencyNames: [{ value: '' }],
    AOffence: [{ value: '' }],
    DAOffence: [{ value: '' }],
    SelectedObligations: [],
    AnyEligibleNomiation: false,
    // FVS Step 12
    SupportingAttachments: [],
    SupportingFilesProvider: '',
    SupportingFilesDescription: '',
    ReportNameField: '',
    UnableToObtainAdoc: false,
    ReportNameFieldErrorHandle: false,
    ReportUploadFileSectionError: '',
    StatutoryUploadFileSectionError: '',
    SignedDeclarationAttachment: [],
    SignedStatutoryProvider: '',
    SignedStatutoryDescription: '',
    SignedDeclarationNameField: '',
    SignedStatutoryFieldErrorHandle: false,
    // FVS Step 13
    OtherSupportingDocNameField: '',
    OtherSupportingAttachments: [],
    OtherSupportingFilesProvider: '',
    OtherSupportingFilesDescription: '',
    OtherReportNameFieldErrorHandle: false,
    ReasonForApplication: '',

    // addtional ob pdf page
    OBLIGATIONS_TO_INCLUDE: '',
    // FVS step 14
    RepresentativeGivenName: '',
    RepresentativeFamilyName: '',
    RepresentativeRelationshipToVictim: '',
    RepresentativeCompanyName: '',
    RepresentativeCompanyPosition: '',
    RepresentativePostalAddress: {
      Address: '',
      LineTwo: '',
      LineOne: '',
      Suburb: '',
      State: '',
      Postcode: '',
      Country: 'Australia',
    },
    RepresentativeEmailAddress: '',
    RepresentativeRequestsEmailCopyBool: '',
    FVSContactNumber: {
      ContactNumber: '',
      NumberType: 'Mobile',
      SecondaryContactNumber: '',
      SecondaryNumberType: 'Mobile',
    },
    FVSContactNumberWarning: '',
    RepresentativeEmailAddressWarning: '',
    RepresentativeAllowsPhoneCommunicationBool: '',
    RepresentativePreferredContactDayTime: '',
    // FVS Step 24
    declaration: false,
    SelectedObNums: '',
    AuthorisedObligation: {} as iObligation,
    EligibleObligations: [],

    // FVS Partial Form data
    ID: '',
    Obligations: [],
    FormData: {
      a: '',
      // is submitted
      submitted: false,
      OBLIGATION_NUMBER: '',
      // FVS Step2 Fields
      OFFENCE_DATE: null,
      HEARING_DATE: null,
      VEHICLE_REGISTRATION: '',
      DRIVER_LICENCE: '',

      // FVS step 4 fields
      SaveYesNo: '',
      SaveOptions: '',
      saveEmail: '',
      saveMobile: '',
      // FVS step 3 Fields
      // Has7DayNotice: null,
      ActionsTakenOnFine: [],
      NoActionsTaken: false,
      HasLinkBwFVSAndFines: null,
      HasEvidenceToSupport: null,
      isUrgent: false,
      // FVS Step 5 Field
      ApplicationLodger: '',
      ConsentToThirdParty: false,
      // FVS Step 6 fields
      FamilyName: '',
      GivenNames: '',
      DOB: null,
      LicenceState: '',
      NoDriverLicence: false,
      StatecountryOfIssue: 'Australia',
      NoFixedAddress: '',
      AdditionalFinesToInclude: '',
      NoResidentialAddress: false,
      FVSResidentialAddress: {
        SearchText: '',
        Address: '',
        LineTwo: '',
        LineOne: '',
        Suburb: '',
        State: '',
        Postcode: '',
        Country: 'Australia',
      },
      DeliveryAddressType: '',
      FVSPostalAddress: {
        SearchText: '',
        Address: '',
        LineTwo: '',
        LineOne: '',
        Suburb: '',
        State: '',
        Postcode: '',
        Country: 'Australia',
      },
      NoSafePostalAddress: false,
      Email: '',
      NoEmail: false,
      IsEmailRequired: null,
      SendEmailCopy: '',
      PhoneApplicant: '',
      IndividualContactNumber: {
        ContactNumber: '',
        NumberType: 'Mobile',
        SecondaryContactNumber: '',
        SecondaryNumberType: 'Mobile',
      },
      EmailWarning: '',
      IndividualContactNumberWarning: '',
      SafestContactTime: '',
      PhoneMessagePrompt: '',
      InterpreterRequiredPrompt: '',
      AlternativeLanguage: '',
      // FVS Step 7 fields
      HasScaredFeelings: null,
      HasRiskAssessment: null,
      ContactSpecialist: null,
      // FVS Step 8 fields
      Gender: '',
      GenderSelfDescribed: '',
      LGBTIQIdentified: null,
      Origin: '',
      EnglishProficiency: '',
      NativeLanguage: '',
      HasDisability: null,
      DisabilityDescription: '',
      // FVS Step 10 fields
      WhatWouldYouLikeToHappen: null,
      FamilyNameOptional: '',
      GivenNamesOptional: '',
      DOBOptional: null,
      DriverLicenceNumberOptional: '',
      LicenceStateOptional: '',
      NoDriverLicenceOptional: false,
      StatecountryOfIssueOptional: 'Australia',
      HowDealtWithFines: '',
      // FVS Step 11 fields
      HasPaymentArrangement: null,
      RemoveFines: null,
      ReincludeFines: null,
      // FVS Step 9
      InfringementNoticeNumber: '',
      SelectedObligationsStep9: [],
      enteredObligationsArray: [{ value: '' }],
      ObligationStatus: '',
      TicketType: '',
      Status: '',
      OffenceCode: '',
      relevantObs: [],
      WhichOtherFines: null,
      InfringementNums: [{ value: '' }],
      AgencyNames: [{ value: '' }],
      AOffence: [{ value: '' }],
      DAOffence: [{ value: '' }],
      // FVS Step 12
      SupportingAttachments: [],
      UnableToObtainAdoc: false,
      SignedDeclarationAttachment: [],
      // FVS Step 13
      OtherSupportingAttachments: [],
      ReasonForApplication: '',
      // FVS Step 14
      RepresentativeGivenName: '',
      RepresentativeFamilyName: '',
      RepresentativeRelationshipToVictim: '',
      RepresentativeCompanyName: '',
      RepresentativeCompanyPosition: '',
      RepresentativePostalAddress: {
        SearchText: '',
        Address: '',
        LineTwo: '',
        LineOne: '',
        Suburb: '',
        State: '',
        Postcode: '',
        Country: 'Australia',
      },
      RepresentativeEmailAddress: '',
      RepresentativeRequestsEmailCopyBool: '',
      FVSContactNumber: {
        ContactNumber: '',
        NumberType: 'Mobile',
        SecondaryContactNumber: '',
        SecondaryNumberType: 'Mobile',
      },
      FVSContactNumberWarning: '',
      RepresentativeEmailAddressWarning: '',
      RepresentativeAllowsPhoneCommunicationBool: '',
      RepresentativePreferredContactDayTime: '',

      // step 18 entered registed fines
      obligations: [],
      RegisteredFinesToInclude: '',
      InfringementFinesToInclude: '',
      AdditionalFinesType: ''
    },
    // File upload failed
    ReportNameFileUplodErrorHandle: false,
    SignedStatutoryFileUploadErrorHandle: false,
    OtherReportNameFileUploadErrorHandle: false,
     // submission error message
  submissionError: '',
  };
  return defaultValues;
};

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
export const getReceiptPayload = (formValues: any): string => `{
    "ID": "",
    "Receipt": "",
    "Obligations": [
        {
            "ID": "",
            "ObligationNO": "${formValues.OBLIGATION_NUMBER}",
            "IsPrimary": "true",
            "ReceptNumberId": ""
        }
    ],
    "SubmittedDate": "",
    "FormTypeId": 7
  }`;

export const getSubmissionPayload = (formValues: iFVSFormValues, submissionNumber: string): iSubmitFVSFormValues => {
  const submitFormValues = formValues;
  const now = new Date();
  const MONTH = now.getMonth() + 1;
  const DATE = now.getDate();
  const YEAR = now.getFullYear();
  const MINUTE = (now.getMinutes() < 10 ? '0' : '') + now.getMinutes();
  const SUBMITTED_TIME = `${now.getHours()}:${MINUTE} ${DATE}/${MONTH}/${YEAR}`;
  const FORM_TYPE = 'FVS';
  const isAllOutstandingFines = formValues.AdditionalFinesType === 'All eligible outstanding fines';
  const isFollowingFines = formValues.AdditionalFinesType === 'The following eligible outstanding fines (please list below)';
  // const isFinesExceptBelow = formValues.AdditionalFinesType === 'All eligible outstanding fines EXCEPT these fines (please list below)';
  // step 5
  const firstParty = formValues.ApplicationLodger === 'LodgedByVictim';
  // step 10
  const selectedObsArray = formValues.SelectedObNums.split(',');
  const selectedObligationsSelfIncludeFirstParty =
    formValues.WhichOtherFines === 'AllFines' ? '' :
    selectedObsArray.length >= 3
      ? 'Refer to attachment'
      : formValues.SelectedObNums.length !== 0
      ? `${formValues.SelectedObNums}, ${formValues.AuthorisedObligation?.Number}`
      : formValues.AuthorisedObligation?.Number;
  // step 18 third party
  const obligationsEntered = formValues.obligations?.map((element) => element.value);
  const selectedObligationsSelfIncludeThirdParty =
        isAllOutstandingFines ? formValues.OBLIGATION_NUMBER
      : obligationsEntered.length >= 3 ? 'Refer to attachment'
      : obligationsEntered.length !== 0 && obligationsEntered[0] ? isFollowingFines ? `${obligationsEntered.join(', ')}, ${formValues.OBLIGATION_NUMBER}`
      : obligationsEntered.join(', ')
      : formValues.OBLIGATION_NUMBER;

  const additonalPdfWithObligationsFirstParty = selectedObsArray.length >= 3 ? `${formValues.SelectedObNums}, ${formValues.AuthorisedObligation?.Number}` : '';
  const additonalPdfWithObligationsThirdParty = obligationsEntered.length >= 3 ? isFollowingFines ? `${obligationsEntered.join(', ')}, ${formValues.OBLIGATION_NUMBER}` : obligationsEntered.join(', ') : '';
  if (formValues.AgencyNames.length > 0) {
    for (let count = 1; count <= formValues.AgencyNames.length; count += 1) {
      formValues[`EnforcementAgency${count}`] = formValues.AgencyNames[count - 1]?.value || '';
      formValues[`Infringement${count}`] = formValues.InfringementNums[count - 1]?.value || '';
      formValues[`AllegedOffence${count}`] = formValues.AOffence[count - 1]?.value || '';
      const doOffenceDate = formValues.DAOffence[count - 1]?.value ? new Date(formValues.DAOffence[count - 1]?.value) : '';
      formValues[`AllegedOffenceDate${count}`] = doOffenceDate ? `${doOffenceDate.getDate()}/${doOffenceDate.getMonth() + 1}/${doOffenceDate.getFullYear()}` : '';
    }
  }
  // step 12, 13 number of attachments
  const totalNumberOfAttachments = formValues.SupportingAttachments?.length + formValues.SignedDeclarationAttachment?.length + formValues.OtherSupportingAttachments?.length;
  const descriptionOfAttachmentsArray = [
    ...(formValues.SupportingAttachments || []),
    ...(formValues.SignedDeclarationAttachment || []),
    ...(formValues.OtherSupportingAttachments || []),
  ];
  let descriptionOfAttachments = '';
  let remoteAttachmentNames = '';
  if (descriptionOfAttachmentsArray) {
    descriptionOfAttachmentsArray.forEach((v) => {
      if (v.FileDescription || v.FileProvider) {
        descriptionOfAttachments += `${v.FileProvider ? v.FileProvider : ''}${v.FileProvider && v.FileDescription ? ' - ' : ''}${v.FileDescription ? v.FileDescription : ''}; `;
      }
      if (v.RemoteFileName) {
        remoteAttachmentNames += `${formValues.OBLIGATION_NUMBER}/${v.RemoteFileName}/${v.RemoteFileName}|`;
      }
    });
  }
  const finalResidentialAddress = !formValues.NoFixedAddress && !formValues.NoResidentialAddress ?
                                `${Object.entries(formValues.FVSResidentialAddress)
                                        .map((entry) => joinAddressFields(entry))
                                        .filter(Boolean)
                                        .join(', ')}` : '';
  const finalPostalAddress = formValues.DeliveryAddressType === 'PostalAddress' || formValues.NoFixedAddress || formValues.NoResidentialAddress ?
                               `${Object.entries(formValues.FVSPostalAddress)
                                      .map((entry) => joinAddressFields(entry))
                                      .filter(Boolean)
                                      .join(', ')}` : '';
  const finalRepPostalAddress = !firstParty ?
                                    `${Object.entries(formValues.RepresentativePostalAddress)
                                    .map((entry) => joinAddressFields(entry))
                                    .filter(Boolean)
                                    .join(', ')}` : '';
  const residentialAddressOnly = !formValues.NoFixedAddress && !formValues.NoResidentialAddress ?
    formValues.FVSResidentialAddress.LineTwo ? `${formValues.FVSResidentialAddress.LineTwo} ${formValues.FVSResidentialAddress.LineOne}` : formValues.FVSResidentialAddress.LineOne : '';
  const postalAddressOnly = formValues.DeliveryAddressType === 'PostalAddress' || formValues.NoFixedAddress || formValues.NoResidentialAddress ?
    formValues.FVSPostalAddress.LineTwo ? `${formValues.FVSPostalAddress.LineTwo} ${formValues.FVSPostalAddress.LineOne}` : formValues.FVSPostalAddress.LineOne : '';
  const repPostalAddressOnly = !firstParty ? formValues.RepresentativePostalAddress.LineTwo ? `${formValues.RepresentativePostalAddress.LineTwo} ${formValues.RepresentativePostalAddress.LineOne}` : formValues.RepresentativePostalAddress.LineOne : '';
  const submitObject: iSubmitFVSFormValues = {
    ...(submitFormValues as iCommonFVSFormValues),

    YourObligationNumber: formValues.OBLIGATION_NUMBER,
    InfringementNoticeNumber: formValues.InfringementNoticeNumber,
    OBLIGATION_NUMBER: formValues.OBLIGATION_NUMBER,
    IdentifyingReference: formValues.OBLIGATION_NUMBER,
    //  Urgent or not Urgent
    Urgent: formValues.isUrgent.toString(),
    // step 3
    LinkYes: formValues.HasLinkBwFVSAndFines || 'false',
    LinkNo: reverseTrueOrFalseSubmission(formValues.HasLinkBwFVSAndFines || 'false'),
    EvidenceYes: formValues.HasEvidenceToSupport || 'false',
    EvidenceNo: reverseTrueOrFalseSubmission(formValues.HasEvidenceToSupport || 'false'),
    // Sheriff7DayNoticeYes: formValues.Has7DayNotice || 'false',
    // Sheriff7DayNoticeNo: reverseTrueOrFalseSubmission(formValues.Has7DayNotice || 'false'),
    Sheriff7DayNoticeYes: formValues.ActionsTakenOnFine.includes('Has7DayNotice').toString() || 'false',
    Sheriff7DayNoticeNo: reverseTrueOrFalseSubmission(formValues.ActionsTakenOnFine.includes('Has7DayNotice').toString() || 'false'),
    SheriffRemoveNumberplates: formValues.ActionsTakenOnFine.includes('NumberPlatesRemoved').toString() || 'false',
    SheriffSeize: formValues.ActionsTakenOnFine.includes('VehicleSeized').toString() || 'false',
    SheriffWheelClamp: formValues.ActionsTakenOnFine.includes('WheelClamped').toString() || 'false',
    LostLicence: formValues.ActionsTakenOnFine.includes('LicenceLost').toString() || 'false',
    AttachmentEarnings: formValues.ActionsTakenOnFine.includes('MadeAttachment').toString() || 'false',
    LandCharge: formValues.ActionsTakenOnFine.includes('RecordedCharge').toString() || 'false',
    NoneApply: formValues.NoActionsTaken.toString(),
    // step 5
    PersonAffected: formValues.ApplicationLodger === 'LodgedByVictim' ? 'true' : 'false',
    ThirdParty: formValues.ApplicationLodger === 'LodgedByRepresentative' ? 'true' : 'false',
    // step 6
    FamilyName: formValues.FamilyName,
    GivenNames: formValues.GivenNames,
    DateOfBirth: `${formValues.DOB?.getDate()}/${(formValues.DOB?.getMonth() || 0) + 1}/${formValues.DOB?.getFullYear()}` || '',
    DriverLicenceNumber: formValues.NoDriverLicence ? '' : formValues.DRIVER_LICENCE,
    StatecountryOfIssue: formValues.NoDriverLicence ? '' : formValues.StatecountryOfIssue === 'Australia' ? formValues.LicenceState : formValues.StatecountryOfIssue,
    ResidentialState: formValues.FVSResidentialAddress.State,
    ResidentialSuburb: formValues.FVSResidentialAddress.Suburb,
    ResidentialAddress: residentialAddressOnly,
    ResidentialPostcode: formValues.FVSResidentialAddress.Postcode,
    ResidentialCountry: formValues.FVSResidentialAddress.State ? formValues.FVSResidentialAddress.Country : '',
    NoFixedAddress: formValues.NoFixedAddress?.toString() || 'false',
    PreferNotToProvide: formValues.NoResidentialAddress.toString(),
    PostalAddress: postalAddressOnly,
    PostalPostcode: formValues.FVSPostalAddress.Postcode,
    PostalSuburb: formValues.FVSPostalAddress.Suburb,
    PostalState: formValues.FVSPostalAddress.State,
    PostalCountry: formValues.FVSPostalAddress.State ? formValues.FVSPostalAddress.Country : '',
    AnotherPostal: formValues.DeliveryAddressType === 'PostalAddress' ? 'true' : 'false',
    SafeToEmailYes: formValues.IsEmailRequired ? (formValues.IsEmailRequired === 'true' ? 'true' : 'false') : '',
    SafeToEmailNo: formValues.IsEmailRequired ? (formValues.IsEmailRequired !== 'true' ? 'true' : 'false') : '',
    EmailAddress: formValues.Email,
    SafeToCallYes: formValues.PhoneApplicant || 'false',
    SafeToCallNo: reverseTrueOrFalseSubmission(formValues.PhoneApplicant || 'false'),
    ContactPhone: formValues.IndividualContactNumber.ContactNumber,
    SafestDaysTimes: formValues.SafestContactTime,
    LeavePhoneMessageYes: formValues.PhoneMessagePrompt ? formValues.PhoneMessagePrompt?.toString() || 'false' : '',
    LeavePhoneMessageNo: formValues.PhoneMessagePrompt ? reverseTrueOrFalseSubmission(formValues.PhoneMessagePrompt || 'false') : '',
    InterpreterYes: formValues.InterpreterRequiredPrompt ? formValues.InterpreterRequiredPrompt || 'false' : '',
    InterpreterNo: formValues.InterpreterRequiredPrompt ? reverseTrueOrFalseSubmission(formValues.InterpreterRequiredPrompt || 'false') : '',
    Language: formValues.AlternativeLanguage,
    // shared between self and third party
    SameAsResidential: formValues.DeliveryAddressType === 'ResidentialAddress' ? 'true' : 'false', // Fineholder's residential address or Residential address
    // AnotherPostal: formValues.OBLIGATION_NUMBER,
    // step 17 (third party - Your details)
    AuthorisedRep: formValues.DeliveryAddressType === 'RepresentativeAddress' ? 'true' : 'false', // Authorised representative’s postal address
    NoSafePostal: formValues.DeliveryAddressType === 'EmailAddress' || formValues.NoSafePostalAddress ? 'true' : 'false',
    // Step 16
    RepGivenNames: !firstParty ? formValues.RepresentativeGivenName : '',
    RepFamilyName: !firstParty ? formValues.RepresentativeFamilyName : '',
    RelationshipPersonAffected: !firstParty ? formValues.RepresentativeRelationshipToVictim : '',
    OrganisationCompanyName: !firstParty ? formValues.RepresentativeCompanyName : '',
    PostitionOrganisationCompany: !firstParty ? formValues.RepresentativeCompanyPosition : '',
    RepPostalAddress: !firstParty ? repPostalAddressOnly : '',
    RepPostalState: !firstParty ? formValues.RepresentativePostalAddress.State : '',
    RepPostalSuburb: !firstParty ? formValues.RepresentativePostalAddress.Suburb : '',
    RepPostalPostcode: !firstParty ? formValues.RepresentativePostalAddress.Postcode : '',
    RepPostalCountry: !firstParty && formValues.RepresentativePostalAddress.State ? formValues.RepresentativePostalAddress.Country : '',
    RepPhoneNumber: !firstParty ? formValues.FVSContactNumber.ContactNumber : '',
    RepCanWeCallYes: !firstParty ? (formValues.RepresentativeAllowsPhoneCommunicationBool === 'Yes' ? 'true' : 'false') : '',
    RepCanWeCallNo: !firstParty ? (formValues.RepresentativeAllowsPhoneCommunicationBool === 'Yes' ? 'false' : 'true') : '',
    RepBestDaysTime: !firstParty ? formValues.RepresentativePreferredContactDayTime : '',
    RepEmailAddress: !firstParty ? formValues.RepresentativeEmailAddress : '',
    // send copy to
    EMAIL_TO: firstParty
      ? formValues.SendEmailCopy === 'true'
        ? formValues.Email
        : ''
      : formValues.RepresentativeRequestsEmailCopyBool === 'Yes'
      ? formValues.RepresentativeEmailAddress
      : '',
    // step 7
    RiskAfraidYes: formValues.HasScaredFeelings || 'false',
    RiskAfraidNo: reverseTrueOrFalseSubmission(formValues.HasScaredFeelings || 'false'),
    SupportAgencyAssessmentNo: formValues.HasRiskAssessment === 'false' ? 'true' : 'false',
    SupportAgencyAssessmentYes: formValues.HasRiskAssessment === 'true' ? 'true' : 'false',
    SupportAgencyAssessmentUnsure: formValues.HasRiskAssessment === 'notKnown' ? 'true' : 'false',
    SupportServicesContactNo: reverseTrueOrFalseSubmission(formValues.ContactSpecialist || 'false'),
    SupportServicesContactYes: formValues.ContactSpecialist || 'false',

    // step 8
    GenderMale: formValues.Gender === 'male' ? 'true' : 'false',
    GenderFemale: formValues.Gender === 'female' ? 'true' : 'false',
    GenderSelfDescribed: formValues.Gender === 'self-described' ? 'true' : 'false',
    GenderSelfDescribedSpecify: formValues.GenderSelfDescribed,
    LGBTIQYes: formValues.LGBTIQIdentified ? formValues.LGBTIQIdentified || 'false' : '',
    LGBTIQNo: formValues.LGBTIQIdentified ? reverseTrueOrFalseSubmission(formValues.LGBTIQIdentified || 'false') : '',
    DisabilityImpairmentYes: formValues.HasDisability ? formValues.HasDisability || 'false' : '',
    DisabilityImpairmentNo: formValues.HasDisability ? reverseTrueOrFalseSubmission(formValues.HasDisability || 'false') : '',
    DisabilityImpairmentSpecify: formValues.DisabilityDescription,
    ATSIYes: formValues.Origin ? (formValues.Origin !== 'neither-aboriginal-and-torres-strait-islander' ? 'true' : 'false') : '',
    ATSINo: formValues.Origin ? (formValues.Origin === 'neither-aboriginal-and-torres-strait-islander' ? 'true' : 'false') : '',
    EnglishNo: formValues.EnglishProficiency === 'not-at-all' ? 'true' : 'false',
    EnglishPoorly: formValues.EnglishProficiency === 'poorly' ? 'true' : 'false',
    EnglishAdequately: formValues.EnglishProficiency === 'adequately' ? 'true' : 'false',
    EnglishWell: formValues.EnglishProficiency === 'very-well' ? 'true' : 'false',
    HomeLanguage: formValues.NativeLanguage,

    // Step 9 third party
    ObligationsAllOutstanding: !firstParty ? formValues.AdditionalFinesType === 'All eligible outstanding fines' ? 'true' : 'false' : formValues.WhichOtherFines === 'AllFines' ? 'true' : 'false',
    ObligationsListed: !firstParty && formValues.AdditionalFinesType === 'The following eligible outstanding fines (please list below)' ? 'true' : 'false',
    ObligationsListedExclude: !firstParty && formValues.AdditionalFinesType === 'All eligible outstanding fines EXCEPT these fines (please list below)' ? 'true' : 'false',

    ObligationNumbersIncludeExclude: firstParty ? selectedObligationsSelfIncludeFirstParty : selectedObligationsSelfIncludeThirdParty,
    // self EnforcementAgency #1 to #10 dynamically added those fields
    // Step 10
    HaveFinesWithdrawn: formValues.WhatWouldYouLikeToHappen === 'FinesWithdrawn' ? 'true' : 'false',
    NominateDriver: formValues.WhatWouldYouLikeToHappen === 'DriverNominated' ? 'true' : 'false',
    DriverGivenNames: formValues.WhatWouldYouLikeToHappen === 'DriverNominated' ? formValues.GivenNamesOptional : '',
    DriverFamilyName: formValues.WhatWouldYouLikeToHappen === 'DriverNominated' ? formValues.FamilyNameOptional : '',
    DriverDriverStateCountryIssue:
      formValues.WhatWouldYouLikeToHappen === 'DriverNominated'
        ? !formValues.DriverLicenceNumberOptional
          ? ''
          : formValues.StatecountryOfIssueOptional === 'Australia'
          ? formValues.LicenceStateOptional
          : formValues.StatecountryOfIssueOptional
        : '',
    DriverDriverLicence: formValues.WhatWouldYouLikeToHappen === 'DriverNominated' ? formValues.DriverLicenceNumberOptional : '',
    DriverDOB:
      formValues.WhatWouldYouLikeToHappen === 'DriverNominated'
        ? formValues.DOBOptional
          ? `${formValues.DOBOptional?.getDate()}/${formValues.DOBOptional?.getMonth() + 1}/${formValues.DOBOptional?.getFullYear()}`
          : ''
        : '',
    CombinationAbove: formValues.WhatWouldYouLikeToHappen === 'AboveCombination' ? 'true' : 'false',
    CombinationDescribe: formValues.WhatWouldYouLikeToHappen === 'AboveCombination' ? formValues.HowDealtWithFines : '',
    // Step 11
    PAYes: formValues.HasPaymentArrangement ? formValues.HasPaymentArrangement || 'false' : '',
    PANo: formValues.HasPaymentArrangement ? reverseTrueOrFalseSubmission(formValues.HasPaymentArrangement || 'false') : '',
    PARemoveYes: formValues.RemoveFines ? formValues.RemoveFines || 'false' : '',
    PARemoveNo: formValues.RemoveFines ? reverseTrueOrFalseSubmission(formValues.RemoveFines || 'false') : '',
    PAProposeYes: formValues.ReincludeFines ? formValues.ReincludeFines || 'false' : '',
    PAProposeNo: formValues.ReincludeFines ? reverseTrueOrFalseSubmission(formValues.ReincludeFines || 'false') : '',
    // Step 12 Need calculated
    NumberAttachments: totalNumberOfAttachments.toString(),
    DocumentDescriptions: descriptionOfAttachments,
    // Step 13
    ReasonsApplication: formValues.ReasonForApplication,
    // Step 24 self
    ApplicantDeclaration: formValues.declaration && firstParty ? 'I agree to the statements' : '',
    ApplicantDeclarationDate: firstParty ? `${DATE}/${MONTH}/${YEAR}` : '',
    // Step 24 third party
    RepDeclaration: formValues.declaration && !firstParty ? 'I consent to this Authorisation' : '',
    RepDeclarationDate: !firstParty ? `${DATE}/${MONTH}/${YEAR}` : '',

    // additional OB pdf page
    OBLIGATIONS_TO_INCLUDE: firstParty ? additonalPdfWithObligationsFirstParty : additonalPdfWithObligationsThirdParty,
    // attachments
    ATTACHMENTS: remoteAttachmentNames,
    // Footer information

    FooterSubmissionNo1: submissionNumber,
    FooterFormType1: FORM_TYPE,
    FooterObligationNo1: formValues.OBLIGATION_NUMBER,
    FooterSubmittedTime1: SUBMITTED_TIME,

    FooterSubmissionNo2: submissionNumber,
    FooterFormType2: FORM_TYPE,
    FooterObligationNo2: formValues.OBLIGATION_NUMBER,
    FooterSubmittedTime2: SUBMITTED_TIME,

    FooterSubmissionNo3: submissionNumber,
    FooterFormType3: FORM_TYPE,
    FooterObligationNo3: formValues.OBLIGATION_NUMBER,
    FooterSubmittedTime3: SUBMITTED_TIME,

    FooterSubmissionNo4: submissionNumber,
    FooterFormType4: FORM_TYPE,
    FooterObligationNo4: formValues.OBLIGATION_NUMBER,
    FooterSubmittedTime4: SUBMITTED_TIME,

    FooterSubmissionNo5: submissionNumber,
    FooterFormType5: FORM_TYPE,
    FooterObligationNo5: formValues.OBLIGATION_NUMBER,
    FooterSubmittedTime5: SUBMITTED_TIME,

    FooterSubmissionNo6: submissionNumber,
    FooterFormType6: FORM_TYPE,
    FooterObligationNo6: formValues.OBLIGATION_NUMBER,
    FooterSubmittedTime6: SUBMITTED_TIME,

    FooterSubmissionNo7: submissionNumber,
    FooterFormType7: FORM_TYPE,
    FooterObligationNo7: formValues.OBLIGATION_NUMBER,
    FooterSubmittedTime7: SUBMITTED_TIME,
  };

  const excludeKeysFromForm: string[] = [
    // fields from iFVSFormValues
    // is submitted
    'submitted',
    'OffenceDateRequired',
    'HearingDateRequired',
    'LicenceRequired',
    'RegistrationRequired',
    'DOBRequired',
    'OFFENCE_DATE',
    'HEARING_DATE',
    'DRIVER_LICENCE',
    'PartialFormID',
    'ID',
    'FormData',
    'Obligations',
    'Attachments',
    'DebtorID',
    'FormTypeID',
    'IsSubscribedEM',
    'IsSubscribedSMS',
    'EMRemeinderSent',
    'SMSRemeinderSent',
    'CreateDate',
    'ExpiryDate',
    'SeriousObligation',
    'DDD',
    'ESI',
    'MarineOffence',
    'submissionNo',
    'DOB',
    'LicenceState',
    'FVSResidentialAddress',
    'HasDifferentResidentialAddress',
    'SummonsAddress',
    'IndividualContactNumber',
    'Email',
    'NoEmail',
    'declaration',
    'SaveYesNo',
    'SaveOptions',
    'saveEmail',
    'saveMobile',
    'a',
    'VEHICLE_REGISTRATION',
    'UserType',
    'NoDriverLicence',
    'CompanyAddress',
    'CompanyPostalAddress',
    'HasDifferentCompanyAddress',
    'DebtorType',
    'RepresentativeGivenName',
    'RepresentativeFamilyName',
    'RepresentativeRelationshipToVictim',
    'RepresentativeCompanyName',
    'RepresentativeCompanyPosition',
    'RepresentativePostalAddress',
    'RepresentativeEmailAddress',
    'RepresentativeRequestsEmailCopyBool',
    'FVSContactNumber',
    'RepresentativeAllowsPhoneCommunicationBool',
    'RepresentativePreferredContactDayTime',
    // FVS excluding UI fields
    'OtherReportNameFieldErrorHandle',
    'OtherSupportingFilesDescription',
    'OtherSupportingFilesProvider',
    'OtherSupportingAttachments',
    'OtherSupportingDocNameField',
    'SignedStatutoryFieldErrorHandle',
    'SignedDeclarationNameField',
    'SignedDeclarationAttachment',
    'StatutoryUploadFileSectionError',
    'ReportUploadFileSectionError',
    'ReportNameFieldErrorHandle',
    'UnableToObtainAdoc',
    'ReportNameField',
    'SupportingFilesDescription',
    'SupportingFilesProvider',
    'SupportingAttachments',
    'DAOffence',
    'AOffence',
    'AgencyNames',
    'InfringementNums',
    'SelectedObligations',
    'AnyEligibleNomiation',
    'AnyPaymentArrangement',
    'AdditionalFinesToInclude',
    'RegisteredFinesToInclude',
    'AdditionalFinesType',
    'InfringementFinesToInclude',
    'OffenceCode',
    'Status',
    'TicketType',
    'ObligationStatus',
    'enteredObligationsArray',
    'obligations',
    'infringementFineArray',
    'SelectedObligationsStep9',
    'ReincludeFines',
    'RemoveFines',
    'HowDealtWithFines',
    'StatecountryOfIssueOptional',
    'NoDriverLicenceOptional',
    'LicenceStateOptional',
    'DriverLicenceNumberOptional',
    'DOBOptional',
    'GivenNamesOptional',
    'FamilyNameOptional',
    'WhatWouldYouLikeToHappen',
    'WhichOtherFines',
    'DisabilityDescription',
    'HasDisability',
    'NativeLanguage',
    'EnglishProficiency',
    'Origin',
    'LGBTIQIdentified',
    'Gender',
    'ContactSpecialist',
    'HasRiskAssessment',
    'HasScaredFeelings',
    'AlternativeLanguage',
    'InterpreterRequiredPrompt',
    'PhoneMessagePrompt',
    'SafestContactTime',
    'PhoneApplicant',
    'SendEmailCopy',
    'IsEmailRequired',
    'NoSafePostalAddress',
    'FVSPostalAddress',
    'DeliveryAddressType',
    'NoResidentialAddress',
    'ConsentToThirdParty',
    'ApplicationLodger',
    'HasPaymentArrangement',
    'HasEvidenceToSupport',
    'HasLinkBwFVSAndFines',
    'NoActionsTaken',
    'ActionsTakenOnFine',
    'AuthorisedObligation',
    'EligibleObligations',
    'SelectedObNums',
    'isUrgent',
    'YourObligationNumber',
    'ReportNameFileUplodErrorHandle',
    'SignedStatutoryFileUploadErrorHandle',
    'OtherReportNameFileUploadErrorHandle',
    'submissionError',
    'relevantObs',
    'EmailWarning',
    'IndividualContactNumberWarning',
    'FVSContactNumberWarning',
    'RepresentativeEmailAddressWarning',
  ];
  excludeKeysFromForm.forEach((value: string) => {
    delete submitObject[value];
  });
  return submitObject;
};

export const FVSSchema = Yup.object().shape({
  saveEmail: Yup.string().email(INVALID_EMAIL).required(INVALID_NUMERIC_FORMAT),
  saveMobile: Yup.string()
    .min(10, INVALID_MOBILE_NUMBER_FORMAT)
    .max(10, INVALID_PHONE_NUMBER_LENGTH)
    .matches(CONTACT_NUMBER_REGEX, INVALID_PHONE_NUMBER)
    .required(INVALID_PHONE_NUMBER),
  SaveYesNo: Yup.string().required(INVALID_YESNO_FORMAT),
  SaveOptions: Yup.string().when('SaveYesNo', {
    is: 'true',
    then: Yup.string().required(INVALID_NUMERIC_FORMAT),
  }),
  OBLIGATION_NUMBER: Yup.string().matches(OBLIGATION_REGEX, INVALID_OBLIGATION_NUMBER).required(INVALID_NUMERIC_FORMAT),
  OFFENCE_DATE: Yup.date().required(EMPTY_DATE).nullable().max(new Date(), INVALID_FUTURE_DATE),
  HEARING_DATE: Yup.date().required(EMPTY_DATE).nullable(),
  DRIVER_LICENCE: Yup.string()
    .required(INVALID_NUMERIC_FORMAT)
    .matches(/^[a-zA-Z0-9 ]*$/, INVALID_LICENCE_FORMAT),
  VEHICLE_REGISTRATION: Yup.string().matches(VEHICLE_REGISTRATION_REGEX, INVALID_VEHICLE_REGISTRATION_NUMBER).required(INVALID_VEHICLE_REGISTRATION_NUMBER),
  // Has7DayNotice: Yup.string().required(INVALID_YESNO_FORMAT).nullable(),
  ActionsTakenOnFine: Yup.array().min(1, EMPTY_CHECKBOX),
  NoActionsTaken: Yup.boolean().oneOf([true], EMPTY_CHECKBOX),
  HasLinkBwFVSAndFines: Yup.string().required(INVALID_YESNO_FORMAT).nullable(),
  HasEvidenceToSupport: Yup.string().required(INVALID_YESNO_FORMAT).nullable(),
  HasScaredFeelings: Yup.string().required(INVALID_YESNO_FORMAT).nullable(),
  HasRiskAssessment: Yup.string().required(INVALID_YESNO_FORMAT).nullable(),
  ContactSpecialist: Yup.string().required(INVALID_YESNO_FORMAT).nullable(),
  HasPaymentArrangement: Yup.string().required(INVALID_YESNO_FORMAT).nullable(),
  RemoveFines: Yup.string().required(INVALID_YESNO_FORMAT).nullable(),
  ReincludeFines: Yup.string().required(INVALID_YESNO_FORMAT).nullable(),
  Gender: Yup.string(),
  GenderSelfDescribed: Yup.string().nullable().matches(FIELDS_WITH_SEPCIFI_CHARS, FIELDS_WITH_SEPCIFI_CHARS_MSG),
  LGBTIQIdentified: Yup.string().nullable(),
  Origin: Yup.string(),
  EnglishProficiency: Yup.string(),
  NativeLanguage: Yup.string().nullable().matches(FIELDS_WITH_SEPCIFI_CHARS, FIELDS_WITH_SEPCIFI_CHARS_MSG),
  HasDisability: Yup.string().nullable(),
  DisabilityDescription: Yup.string().nullable().matches(FIELDS_WITH_SEPCIFI_CHARS, FIELDS_WITH_SEPCIFI_CHARS_MSG),
  ApplicationLodger: Yup.string().required(INVALID_YESNO_FORMAT),
  ConsentToThirdParty: Yup.boolean().when('ApplicationLodger', {
    is: 'LodgedByRepresentative',
    then: Yup.boolean().oneOf([true], MISSING_APPLICATION_LODGING_AGREEMENT),
  }),
  DOB: Yup.date().required(EMPTY_DATE).nullable().max(new Date(), INVALID_FUTURE_DATE),
  FamilyName: Yup.string().matches(NAME_FIELDS_NEW_REGEX, INVALID_NAME_FORMAT).required(INVALID_NUMERIC_FORMAT),
  GivenNames: Yup.string().matches(NAME_FIELDS_NEW_REGEX, INVALID_NAME_FORMAT).required(INVALID_NUMERIC_FORMAT),
  StatecountryOfIssue: Yup.string(),
  LicenceState: Yup.string().required(INVALID_NUMERIC_FORMAT),
  NoDriverLicence: Yup.boolean(),
  WhatWouldYouLikeToHappen: Yup.string().required(INVALID_NUMERIC_FORMAT).nullable(),
  WhichOtherFines: Yup.string().required(INVALID_NUMERIC_FORMAT).nullable(),
  HowDealtWithFines: Yup.string().matches(FIELDS_WITH_SEPCIFI_CHARS, FIELDS_WITH_SEPCIFI_CHARS_MSG).required(INVALID_NUMERIC_FORMAT),
  ReasonForApplication: Yup.string().matches(FREE_TEXT_FIELD_REGEX, INVALID_FREE_TEXT_FIELD_FORMAT).required(INVALID_NUMERIC_FORMAT),
  NoResidentialAddress: Yup.boolean(),
  FVSResidentialAddress: Yup.object().shape({
    SearchText: Yup.string(),
    LineOne: Yup.string().matches(FIELDS_WITH_SEPCIFI_CHARS, FIELDS_WITH_SEPCIFI_CHARS_MSG).required(INVALID_NUMERIC_FORMAT),
    LineTwo: Yup.string().matches(FIELDS_WITH_SEPCIFI_CHARS, FIELDS_WITH_SEPCIFI_CHARS_MSG),
    Suburb: Yup.string().matches(FIELDS_WITH_SEPCIFI_CHARS, FIELDS_WITH_SEPCIFI_CHARS_MSG).required(INVALID_NUMERIC_FORMAT),
    Postcode: Yup.string().matches(FIELDS_WITH_SEPCIFI_CHARS, FIELDS_WITH_SEPCIFI_CHARS_MSG).required(INVALID_NUMERIC_FORMAT),
    Country: Yup.string().required(INVALID_NUMERIC_FORMAT),
    State: Yup.string().when('Country', {
      is: 'Australia',
      then: Yup.string().required(INVALID_NUMERIC_FORMAT),
    }),
  }),
  FVSPostalAddress: Yup.object().shape({
    SearchText: Yup.string(),
    LineOne: Yup.string().matches(FIELDS_WITH_SEPCIFI_CHARS, FIELDS_WITH_SEPCIFI_CHARS_MSG).required(INVALID_NUMERIC_FORMAT),
    LineTwo: Yup.string().matches(FIELDS_WITH_SEPCIFI_CHARS, FIELDS_WITH_SEPCIFI_CHARS_MSG),
    Suburb: Yup.string().matches(FIELDS_WITH_SEPCIFI_CHARS, FIELDS_WITH_SEPCIFI_CHARS_MSG).required(INVALID_NUMERIC_FORMAT),
    Postcode: Yup.string().matches(FIELDS_WITH_SEPCIFI_CHARS, FIELDS_WITH_SEPCIFI_CHARS_MSG).required(INVALID_NUMERIC_FORMAT),
    Country: Yup.string().required(INVALID_NUMERIC_FORMAT),
    State: Yup.string().when('Country', {
      is: 'Australia',
      then: Yup.string().required(INVALID_NUMERIC_FORMAT),
    }),
  }),
  NoSafePostalAddress: Yup.boolean(),
  DeliveryAddressType: Yup.string().required(INVALID_YESNO_FORMAT),
  IsEmailRequired: Yup.string().required(INVALID_YESNO_FORMAT).nullable(),
  Email: Yup.string().email(INVALID_EMAIL).required(INVALID_NUMERIC_FORMAT),
  NoEmail: Yup.boolean(),
  SendEmailCopy: Yup.string().required(INVALID_YESNO_FORMAT).nullable(),
  PhoneApplicant: Yup.string().required(INVALID_YESNO_FORMAT).nullable(),
  IndividualContactNumber: Yup.object().shape({
    ContactNumber: Yup.string().max(15, INVALID_PHONE_NUMBER_LENGTH_15).matches(CONTACT_NUMBER_REGEX, INVALID_PHONE_NUMBER).required(INVALID_PHONE_NUMBER),
    NumberType: Yup.string(),
  }),
  SafestContactTime: Yup.string().matches(FIELDS_WITH_SEPCIFI_CHARS, FIELDS_WITH_SEPCIFI_CHARS_MSG).required(INVALID_NUMERIC_FORMAT),
  PhoneMessagePrompt: Yup.string().required(INVALID_YESNO_FORMAT).nullable(),
  InterpreterRequiredPrompt: Yup.string().required(INVALID_YESNO_FORMAT).nullable(),
  AlternativeLanguage: Yup.string().matches(FIELDS_WITH_SEPCIFI_CHARS, FIELDS_WITH_SEPCIFI_CHARS_MSG).required(INVALID_NUMERIC_FORMAT),
  // step 9 and 18
  AgencyNames: Yup.array()
    .min(1)
    .of(
      Yup.object().shape({
        value: Yup.string().matches(FIELDS_WITH_SEPCIFI_CHARS, FIELDS_WITH_SEPCIFI_CHARS_MSG).required(INVALID_NUMERIC_FORMAT),
      }),
    ),
    InfringementNums: Yup.array()
    .min(1)
    .of(
      Yup.object().shape({
        value: Yup.string().nullable().matches(FIELDS_WITH_SEPCIFI_CHARS, FIELDS_WITH_SEPCIFI_CHARS_MSG),
      }),
    ),
    AOffence: Yup.array()
    .min(1)
    .of(
      Yup.object().shape({
        value: Yup.string().nullable().matches(FIELDS_WITH_SEPCIFI_CHARS, FIELDS_WITH_SEPCIFI_CHARS_MSG),
      }),
    ),
  obligations: Yup.array()
    .min(1)
    .of(
      Yup.object().shape({
        value: Yup.string().matches(OBLIGATION_REGEX, INVALID_OBLIGATION_NUMBER).required(INVALID_NUMERIC_FORMAT),
      }),
    ),
  DOBOptional: Yup.date().nullable().max(new Date(), INVALID_FUTURE_DATE),
  AdditionalFinesType: Yup.string().required(INVALID_YESNO_FORMAT),
  RegisteredFinesToInclude: Yup.string().required(INVALID_YESNO_FORMAT),
  InfringementFinesToInclude: Yup.string().required(INVALID_YESNO_FORMAT),
  // step 12 13
  OtherSupportingFilesDescription: Yup.string().matches(FIELDS_WITH_SEPCIFI_CHARS, FIELDS_WITH_SEPCIFI_CHARS_MSG),
  SupportingFilesDescription: Yup.string().matches(FIELDS_WITH_SEPCIFI_CHARS, FIELDS_WITH_SEPCIFI_CHARS_MSG),
  ReportNameFieldErrorHandle: Yup.boolean().oneOf([false], INVALID_FILE_SIZE),
  ReportNameFileUplodErrorHandle: Yup.boolean().oneOf([false], FILE_UPLOAD_FAIL),
  SignedStatutoryFileUploadErrorHandle: Yup.boolean().oneOf([false], FILE_UPLOAD_FAIL),
  OtherReportNameFileUploadErrorHandle: Yup.boolean().oneOf([false], FILE_UPLOAD_FAIL),
  SignedDeclarationAttachment: Yup.array().min(1, EMPTY_CHECKBOX),
  UnableToObtainAdoc: Yup.boolean(),
  ReportUploadFileSectionError: Yup.boolean().when(['UnableToObtainAdoc', 'SupportingAttachments'], {
    is: (UnableToObtainAdoc: boolean, SupportingAttachments: []) => !UnableToObtainAdoc && SupportingAttachments.length < 1,
    then: Yup.boolean().required('Please attach a document'),
  }),
  StatutoryUploadFileSectionError: Yup.boolean().when('SignedDeclarationAttachment', {
    is: (SignedDeclarationAttachment: []) => SignedDeclarationAttachment.length < 1,
    then: Yup.boolean().required('Please attach a document'),
  }),
  SignedStatutoryFieldErrorHandle: Yup.boolean().oneOf([false], INVALID_FILE_SIZE),
  OtherReportNameFieldErrorHandle: Yup.boolean().oneOf([false], INVALID_FILE_SIZE),
  declaration: Yup.boolean().oneOf([true], MISSING_DECLARATION_AGREEMENT),
  // Step 14
  RepresentativeGivenName: Yup.string().matches(NAME_FIELDS_NEW_REGEX, INVALID_NAME_FORMAT).required(INVALID_NUMERIC_FORMAT),
  RepresentativeFamilyName: Yup.string().matches(NAME_FIELDS_NEW_REGEX, INVALID_NAME_FORMAT).required(INVALID_NUMERIC_FORMAT),
  RepresentativeRelationshipToVictim: Yup.string().matches(FIELDS_WITH_SEPCIFI_CHARS, FIELDS_WITH_SEPCIFI_CHARS_MSG).required(INVALID_NUMERIC_FORMAT),
  RepresentativeCompanyName: Yup.string().nullable().max(80).matches(ORGANISATION_NAME_REGEX, INVALID_ORG_NAME_FORMAT),
  RepresentativeCompanyPosition: Yup.string().nullable().matches(FIELDS_WITH_SEPCIFI_CHARS, FIELDS_WITH_SEPCIFI_CHARS_MSG),
  RepresentativePostalAddress: Yup.object().shape({
    SearchText: Yup.string(),
    LineOne: Yup.string().matches(FIELDS_WITH_SEPCIFI_CHARS, FIELDS_WITH_SEPCIFI_CHARS_MSG).required(INVALID_NUMERIC_FORMAT),
    LineTwo: Yup.string().matches(FIELDS_WITH_SEPCIFI_CHARS, FIELDS_WITH_SEPCIFI_CHARS_MSG),
    Suburb: Yup.string().matches(FIELDS_WITH_SEPCIFI_CHARS, FIELDS_WITH_SEPCIFI_CHARS_MSG).required(INVALID_NUMERIC_FORMAT),
    Postcode: Yup.string().matches(FIELDS_WITH_SEPCIFI_CHARS, FIELDS_WITH_SEPCIFI_CHARS_MSG).required(INVALID_NUMERIC_FORMAT),
    Country: Yup.string().required(INVALID_NUMERIC_FORMAT),
    State: Yup.string().when('Country', {
      is: 'Australia',
      then: Yup.string().required(INVALID_NUMERIC_FORMAT),
    }),
  }),
  RepresentativeEmailAddress: Yup.string().email(INVALID_EMAIL).required(INVALID_NUMERIC_FORMAT),
  RepresentativeRequestsEmailCopyBool: Yup.string().required(INVALID_YESNO_FORMAT),
  FVSContactNumber: Yup.object().shape({
    ContactNumber: Yup.string().max(15, INVALID_PHONE_NUMBER_LENGTH_15).matches(CONTACT_NUMBER_REGEX, INVALID_PHONE_NUMBER).required(INVALID_PHONE_NUMBER),
    NumberType: Yup.string(),
    SecondaryContactNumber: Yup.string().max(15, INVALID_PHONE_NUMBER_LENGTH_15).matches(CONTACT_NUMBER_REGEX, INVALID_PHONE_NUMBER),
    SecondaryNumberType: Yup.string(),
  }),
  RepresentativeAllowsPhoneCommunicationBool: Yup.string().required(INVALID_YESNO_FORMAT),
  RepresentativePreferredContactDayTime: Yup.string().when('RepresentativeAllowsPhoneCommunicationBool', {
    is: 'Yes',
    then: Yup.string().matches(FIELDS_WITH_SEPCIFI_CHARS, FIELDS_WITH_SEPCIFI_CHARS_MSG).required(INVALID_NUMERIC_FORMAT),
  }),
  // step 19
  GivenNamesOptional: Yup.string().nullable().matches(NAME_FIELDS_NEW_REGEX, INVALID_NAME_FORMAT),
  FamilyNameOptional: Yup.string().nullable().matches(NAME_FIELDS_NEW_REGEX, INVALID_NAME_FORMAT),
  DriverLicenceNumberOptional: Yup.string().nullable().matches(NAME_FIELDS_REGEX, INVALID_NAME_FORMAT),

});

const { FAMILYVIOLENCESCHEME } = FormType;

export const FVSMetaData: iFormMetaData = {
  pagesSegments: {
    step0: {
      progressStep: ProgressStep.START,
      validationKeys: (values: FormikValues) => [],
    },
    step1: {
      progressStep: ProgressStep.START,
      validationKeys: (values: FormikValues) => keys(values, FAMILYVIOLENCESCHEME).page1,
    },
    step2: {
      progressStep: ProgressStep.START,
      validationKeys: (values: FormikValues) => keys(values, FAMILYVIOLENCESCHEME).page2,
    },
    step3: {
      progressStep: ProgressStep.START,
      validationKeys: (values: FormikValues) => keys(values, FAMILYVIOLENCESCHEME).page3,
    },
    step4: {
      progressStep: ProgressStep.START,
      validationKeys: (values: FormikValues) => keys(values, FAMILYVIOLENCESCHEME).page4,
    },
    step5: {
      progressStep: ProgressStep.DETAILS,
      validationKeys: (values: FormikValues) => keys(values, FAMILYVIOLENCESCHEME).page5,
    },
    step6: {
      progressStep: ProgressStep.DETAILS,
      validationKeys: (values: FormikValues) => keys(values, FAMILYVIOLENCESCHEME).page6,
    },
    step7: {
      progressStep: ProgressStep.DETAILS,
      validationKeys: (values: FormikValues) => keys(values, FAMILYVIOLENCESCHEME).page7,
    },
    step8: {
      progressStep: ProgressStep.DETAILS,
      validationKeys: (values: FormikValues) => keys(values, FAMILYVIOLENCESCHEME).page8,
    },
    step9: {
      progressStep: ProgressStep.DETAILS,
      validationKeys: (values: FormikValues) => keys(values, FAMILYVIOLENCESCHEME).page9,
    },
    step10: {
      progressStep: ProgressStep.DETAILS,
      validationKeys: (values: FormikValues) => keys(values, FAMILYVIOLENCESCHEME).page10,
    },
    step11: {
      progressStep: ProgressStep.DETAILS,
      validationKeys: (values: FormikValues) => keys(values, FAMILYVIOLENCESCHEME).page11,
    },
    step12: {
      progressStep: ProgressStep.DETAILS,
      validationKeys: (values: FormikValues) => keys(values, FAMILYVIOLENCESCHEME).page12,
    },
    step13: {
      progressStep: ProgressStep.DETAILS,
      validationKeys: (values: FormikValues) => keys(values, FAMILYVIOLENCESCHEME).page13,
    },
    step14: {
      progressStep: ProgressStep.DETAILS,
      validationKeys: (values: FormikValues) => keys(values, FAMILYVIOLENCESCHEME).page14,
    },
    step15: {
      progressStep: ProgressStep.DETAILS,
      validationKeys: (values: FormikValues) => keys(values, FAMILYVIOLENCESCHEME).page15,
    },
    step16: {
      progressStep: ProgressStep.DETAILS,
      validationKeys: (values: FormikValues) => keys(values, FAMILYVIOLENCESCHEME).page16,
    },
    step17: {
      progressStep: ProgressStep.DETAILS,
      validationKeys: (values: FormikValues) => keys(values, FAMILYVIOLENCESCHEME).page17,
    },
    step18: {
      progressStep: ProgressStep.DETAILS,
      validationKeys: (values: FormikValues) => keys(values, FAMILYVIOLENCESCHEME).page18,
    },
    step19: {
      progressStep: ProgressStep.DETAILS,
      validationKeys: (values: FormikValues) => keys(values, FAMILYVIOLENCESCHEME).page19,
    },
    step20: {
      progressStep: ProgressStep.DETAILS,
      validationKeys: (values: FormikValues) => keys(values, FAMILYVIOLENCESCHEME).page20,
    },
    step21: {
      progressStep: ProgressStep.DETAILS,
      validationKeys: (values: FormikValues) => keys(values, FAMILYVIOLENCESCHEME).page21,
    },
    step22: {
      progressStep: ProgressStep.DETAILS,
      validationKeys: (values: FormikValues) => keys(values, FAMILYVIOLENCESCHEME).page22,
    },
    step23: {
      progressStep: ProgressStep.CHECK_CONFIRM,
      validationKeys: (values: FormikValues) => keys(values, FAMILYVIOLENCESCHEME).page23,
    },
    step24: {
      progressStep: ProgressStep.CHECK_CONFIRM,
      validationKeys: (values: FormikValues) => keys(values, FAMILYVIOLENCESCHEME).page24,
    },
    step25: {
      progressStep: ProgressStep.DONE,
      validationKeys: (values: FormikValues) => [],
    },
  },
};

export const getSummaryScreen = (values: iFVSFormValues): iSummary[] => {
  const page3 = {
    title: 'Before you continue',
    editLink: '/step3',
    fields: [
      // [{ title: "Has a sheriff's officer served you with a 7 Day Notice?", value: values.Has7DayNotice === 'true' ? 'Yes' : 'No' }],
      // s[{ title: "Has a sheriff's officer served you with a 7 Day Notice?", value: values.ActionsTakenOnFine.includes('Has7DayNotice').toString() != null ? 'Yes' : 'No' }],
      [
        {
          title: 'Has any action been taken for this fine?',
          value:
            values.ActionsTakenOnFine.length !== 0 && !values.ActionsTakenOnFine.includes('None')
              ? `${values.ActionsTakenOnFine.map((entry) => {
                  if (entry === 'Has7DayNotice') return "A sheriff's officer served you with a 7 Day Notice";
                  if (entry === 'NumberPlatesRemoved') return "A sheriff's officer has removed your numberplates";
                  if (entry === 'WheelClamped') return "A sheriff's officer has wheel clamped your vehicle";
                  if (entry === 'LicenceLost') return "You've lost your licence (either due to licence sanction or as a result of demerit points)";
                  if (entry === 'MadeAttachment') return 'The Director, Fines Victoria has made an attachment of earnings or debt direction';
                  if (entry === 'RecordedCharge') return 'The Director, Fines Victoria has recorded a charge over land that you own';
                  if (entry === 'VehicleSeized') return "A sheriff's officer has seized your vehicle";
                  return '';
                }).join('; ')}`
              : 'None of these apply',
        },
      ],
      [
        {
          title: 'Is there a link between the experience of family violence and the offending conduct or being unable to nominate the responsible driver?',
          value: values.HasLinkBwFVSAndFines === 'true' ? 'Yes' : 'No',
        },
      ],
      [
        {
          title: 'Do you have evidence to support the application?',
          value: values.HasEvidenceToSupport === 'true' ? 'Yes' : 'No',
        },
      ],
    ],
  };

  const page5 = {
    title: 'Who is lodging the application?',
    editLink: '/step5',
    fields: [
      [
        {
          title: '',
          value:
            values.ApplicationLodger === 'LodgedByVictim'
              ? 'I am the person affected by family violence'
              : "I am the affected person's authorised representative, lawyer or advocate",
        },
      ],
    ],
  };

  const isPostalAddressEmpty =
    values.FVSPostalAddress.LineOne === '' && values.FVSPostalAddress.Postcode === '' && values.FVSPostalAddress.State === '' && values.FVSPostalAddress.Suburb === '';
  const isResidentialAddressEmpty =
    values.FVSResidentialAddress.LineOne === '' &&
    values.FVSResidentialAddress.Postcode === '' &&
    values.FVSResidentialAddress.State === '' &&
    values.FVSResidentialAddress.Suburb === '';
  const page6 = {
    title: 'Your details',
    editLink: '/step6',
    fields: [
      [{ title: 'Given name(s)', value: values.GivenNames }],
      [{ title: 'Family name', value: values.FamilyName }],
      [{ title: 'Date of birth', value: values.DOB ? `${values.DOB.getDate()}/${values.DOB.getMonth() + 1}/${values.DOB.getFullYear()}` : 'n/a' }],
      [
        values.NoDriverLicence
          ? { title: 'Driver licence number', value: 'n/a' }
          : { title: 'Driver licence number', value: values.DRIVER_LICENCE ? values.DRIVER_LICENCE : 'n/a' },
      ],
      [
        values.NoDriverLicence
          ? { title: 'Place of issue', value: 'n/a' }
          : {
              title: 'Place of issue',
              value:
                values.StatecountryOfIssue === 'Australia' ? (values.LicenceState ? values.LicenceState : 'n/a') : values.StatecountryOfIssue ? values.StatecountryOfIssue : 'n/a',
            },
      ],
      !values.NoFixedAddress && !values.NoResidentialAddress
        ? [
            {
              title: 'Residential address',
              value: `${Object.entries(values.FVSResidentialAddress)
                .map((entry) => joinAddressFields(entry))
                .filter(Boolean)
                .join(', ')}`,
            },
          ]
        : [],
      !values.NoFixedAddress ? [{ title: "Don't have a fixed address", value: 'No' }] : [],
      values.NoFixedAddress ? [{ title: "Don't have a fixed address", value: 'Yes' }] : [],
      values.NoResidentialAddress
        ? [{ title: 'Prefer not to provide your residential address ', value: 'Yes' }]
        : [{ title: 'Prefer not to provide your residential address', value: 'No' }],
      values.DeliveryAddressType === 'ResidentialAddress'
        ? [{ title: 'Preferred address for receiving correspondence', value: 'Residential address' }]
        : values.DeliveryAddressType === 'PostalAddress'
        ? [{ title: 'Preferred address for receiving correspondence', value: 'Another postal address' }]
        : values.DeliveryAddressType === 'EmailAddress'
        ? [{ title: 'Preferred address for receiving correspondence', value: 'Email address' }]
        : [],
      values.DeliveryAddressType === 'PostalAddress' || values.NoFixedAddress || values.NoResidentialAddress
        ? [
            {
              title: 'Postal address',
              value: `${Object.entries(values.FVSPostalAddress)
                .map((entry) => joinAddressFields(entry))
                .filter(Boolean)
                .join(', ')}`,
            },
          ]
        : [],
      values.NoFixedAddress || values.NoResidentialAddress ? [{ title: "Don't have a safe postal address", value: values.NoSafePostalAddress ? 'Yes' : 'No' }] : [],
      (!isResidentialAddressEmpty || !isPostalAddressEmpty) &&
      (values.DeliveryAddressType === 'ResidentialAddress' || values.DeliveryAddressType === 'PostalAddress' || values.NoResidentialAddress || values.NoFixedAddress)
        ? [{ title: 'Is it safe to email you about your application?', value: values.IsEmailRequired === 'true' ? 'Yes' : 'No' }]
        : [],
      (isResidentialAddressEmpty && isPostalAddressEmpty) || values.DeliveryAddressType === 'EmailAddress' || values.IsEmailRequired === 'true'
        ? [{ title: 'Email', value: values.Email }]
        : [],
      values.Email !== ''
        ? [{ title: 'Would you like to receive a copy of the completed application at the email address provided?', value: values.SendEmailCopy === 'true' ? 'Yes' : 'No' }]
        : [],
      [{ title: 'Is it safe to phone you to discuss your application?', value: values.PhoneApplicant === 'true' ? 'Yes' : 'No' }],
      values.PhoneApplicant === 'true' ? [{ title: 'Contact phone number', value: values.IndividualContactNumber.ContactNumber }] : [],
      values.PhoneApplicant === 'true' ? [{ title: 'What are the safest days and time to phone?', value: values.SafestContactTime }] : [],
      values.PhoneApplicant === 'true' ? [{ title: 'Can we leave a phone message on this number?', value: values.PhoneMessagePrompt === 'true' ? 'Yes' : 'No' }] : [],
      values.PhoneApplicant === 'true' ? [{ title: 'Do you need an interpreter to assist?', value: values.InterpreterRequiredPrompt === 'true' ? 'Yes' : 'No' }] : [],
      values.InterpreterRequiredPrompt === 'true' ? [{ title: 'Language', value: values.AlternativeLanguage }] : [],
    ],
  };

  const page7 = {
    title: 'Your risk and support details',
    editLink: '/step7',
    fields: [
      [
        {
          title: riskAndSupportDetails.step7.fields.hasScaredFeelings.title,
          value: values.HasScaredFeelings === 'true' ? 'Yes' : 'No',
        },
      ],
      [
        {
          title: riskAndSupportDetails.step7.fields.hasRiskAssessment.title,
          value: values.HasRiskAssessment === 'notKnown' ? "I don't know" : values.HasRiskAssessment === 'true' ? 'Yes' : 'No',
        },
      ],
      [
        {
          title: riskAndSupportDetails.step7.fields.contactSpecialist.title,
          value: values.ContactSpecialist === 'true' ? 'Yes' : 'No',
        },
      ],
    ],
  };
  const page8 = {
    title: 'Your background and identity',
    editLink: '/step8',
    fields: [
      [
        {
          title: backgroundAndIdentityDetails.step8.fields.gender.title,
          value: values.Gender !== '' ? values.Gender.charAt(0).toUpperCase() + values.Gender.split('-').join(' ').slice(1) : 'n/a',
        },
      ],
      values.Gender === 'self-described'
        ? [
            {
              title: backgroundAndIdentityDetails.step8.fields.genderDescription.title,
              value: values.GenderSelfDescribed !== '' ? values.GenderSelfDescribed : 'n/a',
            },
          ]
        : [],
      [
        {
          title: backgroundAndIdentityDetails.step8.fields.lgtiqIdentified.title,
          value: values.LGBTIQIdentified === null ? 'n/a' : values.LGBTIQIdentified === 'true' ? 'Yes' : 'No',
        },
      ],
      [
        {
          title: backgroundAndIdentityDetails.step8.fields.origin.title,
          value: values.Origin !== '' ? values.Origin.charAt(0).toUpperCase() + values.Origin.split('-').join(' ').slice(1) : 'n/a',
        },
      ],
      [
        {
          title: backgroundAndIdentityDetails.step8.fields.englishProficiency.title,
          value: values.EnglishProficiency !== '' ? values.EnglishProficiency.charAt(0).toUpperCase() + values.EnglishProficiency.split('-').join(' ').slice(1) : 'n/a',
        },
      ],
      values.EnglishProficiency === 'not-at-all' || values.EnglishProficiency === 'poorly'
        ? [
            {
              title: backgroundAndIdentityDetails.step8.fields.nativeLanguage.title,
              value: values.NativeLanguage !== '' ? values.NativeLanguage : 'n/a',
            },
          ]
        : [],
      [
        {
          title: backgroundAndIdentityDetails.step8.fields.isDisabled.title,
          value: values.HasDisability === null ? 'n/a' : values.HasDisability === 'true' ? 'Yes' : 'No',
        },
      ],
      values.HasDisability === 'true'
        ? [
            {
              title: backgroundAndIdentityDetails.step8.fields.disabilityDescription.title,
              value: values.DisabilityDescription !== '' ? values.DisabilityDescription : 'n/a',
            },
          ]
        : [],
    ],
  };

  const checkFines = values.SelectedObligationsStep9.map((fine) => {
    if (fine.checked) return fine.number.toString();
    return '';
  })
    .filter(Boolean)
    .join('; ');
  const page9 = {
    title: 'Your fines',
    editLink: '/step9',
    fields: [
      values.relevantObs.length !== 0
      ? [
        {
          title: 'Which other fines do you want to include in this application?',
          value: values.WhichOtherFines === 'AllFines' ? 'All eligible outstanding fines' : values.WhichOtherFines === 'SomeFines' ? 'Some eligible outstanding fines' : values.WhichOtherFines === 'NoFines' ? 'No additional fines' : ''
        }
      ]
      : [],
      [
        {
          title: 'Fines to include in application',
          value: checkFines !== '' ? `${checkFines}; ${values.AuthorisedObligation.Number}` : values.AuthorisedObligation.Number,
        },
      ],
      [
        {
          title: 'Do you have any additional fines that are not listed above you would us to include in the application?',
          value: values.AdditionalFinesToInclude !== '' ? (values.AdditionalFinesToInclude === 'true' ? 'Yes' : 'No') : 'n/a',
        },
      ],
      values.AdditionalFinesToInclude === 'true'
        ? [
            {
              title: 'Any addtional fines',
              value: listUnregisteredFines(values, values.AgencyNames).join('\n'),
            },
          ]
        : [],
    ],
  };
  const page10 = {
    title: 'What would you like to happen?',
    editLink: '/step10',
    fields: [] as iSummaryField[][],
  };
  if (values.WhatWouldYouLikeToHappen === 'FinesWithdrawn') page10.fields.push([{ title: 'If application is successful, I wish to:', value: 'Have the fine(s) withdrawn' }]);
  if (values.WhatWouldYouLikeToHappen === 'DriverNominated') {
    page10.fields.push(
      [{ title: 'If application is successful, I wish to:', value: 'Nominate the driver that was in control of the vehicle at the time of the offence(s)' }],
      [{ title: likelyPossibilities.step10.fields.givenNameOptional.title, value: values.GivenNamesOptional !== '' ? values.GivenNamesOptional : 'n/a' }],
      [{ title: likelyPossibilities.step10.fields.familyNameOptional.title, value: values.FamilyNameOptional !== '' ? values.FamilyNameOptional : 'n/a' }],
      [
        {
          title: likelyPossibilities.step10.fields.dateOfBirthOptional.title,
          value: values.DOBOptional ? `${values.DOBOptional.getDate()}/${values.DOBOptional.getMonth() + 1}/${values.DOBOptional.getFullYear()}` : 'n/a',
        },
      ],
      [{ title: likelyPossibilities.step10.fields.driverLicenceOptional.title, value: values.DriverLicenceNumberOptional !== '' ? values.DriverLicenceNumberOptional : 'n/a' }],
      [
        {
          title: 'Place of issue',
          value:
            values.StatecountryOfIssueOptional === 'Australia'
              ? values.LicenceStateOptional
                ? values.LicenceStateOptional
                : 'n/a'
              : values.StatecountryOfIssueOptional
              ? values.StatecountryOfIssueOptional
              : 'n/a',
        },
      ],
    );
  }
  if (values.WhatWouldYouLikeToHappen === 'AboveCombination') {
    page10.fields.push(
      [{ title: 'If application is successful, I wish to:', value: 'A combination of the above' }],
      [{ title: likelyPossibilities.step10.fields.howDealtWithFines.title, value: values.HowDealtWithFines }],
    );
  }
  const page11 = {
    title: 'Payment arrangements',
    editLink: '/step11',
    fields: [
      [
        {
          title: paymentArrangements.step11.fields.removeFines.title,
          value: values.RemoveFines === 'true' ? 'Yes' : 'No',
        },
      ],
      values.RemoveFines === 'true'
        ? [
            {
              title: paymentArrangements.step11.fields.reincludeFines.title,
              value: values.ReincludeFines === 'true' ? 'Yes' : 'No',
            },
          ]
        : [],
    ],
  };
  const page12 = {
    title: 'Supporting documents',
    editLink: '/step12',
    fields: [
      [
        {
          title: '',
          value: values.SupportingAttachments.map((attachment) => displayFileDetails(attachment))
            .filter(Boolean)
            .join('\n'),
        },
      ],
      [
        {
          title: '',
          value: values.SignedDeclarationAttachment.map((attachment) => displayFileDetails(attachment))
            .filter(Boolean)
            .join('\n'),
        },
      ],
    ],
  };

  const checkOptSupportingDoc = values.OtherSupportingAttachments.map((attachment) => displayFileDetails(attachment))
    .filter(Boolean)
    .join('\n');
  const page13 = {
    title: 'Reasons for application',
    editLink: '/step13',
    fields: [
      [
        {
          title: 'Your reason',
          value: values.ReasonForApplication,
        },
      ],
      [
        {
          title: 'Other supporting documents',
          value: checkOptSupportingDoc !== '' ? checkOptSupportingDoc : 'n/a',
        },
      ],
    ],
  };
  const page14 = {
    title: 'Your details (authorised representative)',
    editLink: '/step14',
    fields: [
      [{ title: 'Given name(s)', value: values.RepresentativeGivenName }],
      [{ title: 'Family name', value: values.RepresentativeFamilyName }],
      [{ title: 'Relationship to person affected by the family violence', value: values.RepresentativeRelationshipToVictim }],
      [
        values.RepresentativeCompanyName !== ''
          ? { title: 'Organisation / company name', value: values.RepresentativeCompanyName }
          : { title: 'Organisation / company name', value: 'n/a' },
      ],
      [
        values.RepresentativeCompanyPosition !== ''
          ? { title: 'Position in organisation / company', value: values.RepresentativeCompanyPosition }
          : { title: 'Position in organisation / company', value: 'n/a' },
      ],
      [
        {
          title: 'Postal address',
          value: `${Object.entries(values.RepresentativePostalAddress)
            .map((entry) => joinAddressFields(entry))
            .filter(Boolean)
            .join(', ')}`,
        },
      ],
      [{ title: 'Email address', value: values.RepresentativeEmailAddress }],
      [{ title: 'Would you like to receive a copy of the completed application at your email address?', value: values.RepresentativeRequestsEmailCopyBool }],
      [{ title: 'Contact phone number', value: values.FVSContactNumber.ContactNumber }],
      [{ title: 'Can we phone you regarding this application?', value: values.RepresentativeAllowsPhoneCommunicationBool }],
      values.RepresentativeAllowsPhoneCommunicationBool === 'Yes'
        ? [{ title: 'What are the best days and times to phone?', value: values.RepresentativePreferredContactDayTime }]
        : [],
    ],
  };
  const page15 = {
    title: "Fineholder's details",
    editLink: '/step15',
    fields: [
      [{ title: 'Given name(s)', value: values.GivenNames }],
      [{ title: 'Family name', value: values.FamilyName }],
      [{ title: 'Date of birth', value: values.DOB ? `${values.DOB.getDate()}/${values.DOB.getMonth() + 1}/${values.DOB.getFullYear()}` : 'n/a' }],
      [
        values.NoDriverLicence
          ? { title: 'Driver licence number', value: 'n/a' }
          : { title: 'Driver licence number', value: values.DRIVER_LICENCE ? values.DRIVER_LICENCE : 'n/a' },
      ],
      [
        values.NoDriverLicence
          ? { title: 'Place of issue', value: 'n/a' }
          : {
              title: 'Place of issue',
              value:
                values.StatecountryOfIssue === 'Australia' ? (values.LicenceState ? values.LicenceState : 'n/a') : values.StatecountryOfIssue ? values.StatecountryOfIssue : 'n/a',
            },
      ],
      !values.NoFixedAddress && !values.NoResidentialAddress
        ? [
            {
              title: 'Residential address',
              value: `${Object.entries(values.FVSResidentialAddress)
                .map((entry) => joinAddressFields(entry))
                .filter(Boolean)
                .join(', ')}`,
            },
          ]
        : [],
      values.NoFixedAddress ? [{ title: "Don't have a fixed address", value: 'Yes' }] : [{ title: "Don't have a fixed address", value: 'No' }],
      values.NoResidentialAddress
        ? [{ title: 'Prefer not to provide your residential address ', value: 'Yes' }]
        : [{ title: 'Prefer not to provide your residential address ', value: 'No' }],
      values.DeliveryAddressType === 'ResidentialAddress'
        ? [{ title: 'Preferred address for receiving correspondence', value: "Fineholder's Residential address" }]
        : values.DeliveryAddressType === 'PostalAddress'
        ? [{ title: 'Preferred address for receiving correspondence', value: 'Another postal address' }]
        : [{ title: 'Preferred address for receiving correspondence', value: "Authorised representative's postal address" }],
      values.DeliveryAddressType === 'PostalAddress' || values.NoFixedAddress || values.NoResidentialAddress
        ? [
            {
              title: 'Postal address',
              value: `${Object.entries(values.FVSPostalAddress)
                .map((entry) => joinAddressFields(entry))
                .filter(Boolean)
                .join(', ')}`,
            },
          ]
        : [],
      [{ title: 'Is it safe to email you about your application?', value: values.IsEmailRequired === 'true' ? 'Yes' : 'No' }],
      values.IsEmailRequired === 'true' ? [{ title: 'Email', value: values.Email }] : [],
      [{ title: 'Is it safe to phone you to discuss your application?', value: values.PhoneApplicant === 'true' ? 'Yes' : 'No' }],
      values.PhoneApplicant === 'true' ? [{ title: 'Contact phone number', value: values.IndividualContactNumber.ContactNumber }] : [],
      values.PhoneApplicant === 'true' ? [{ title: 'What are the safest days and time to phone?', value: values.SafestContactTime }] : [],
      values.PhoneApplicant === 'true' ? [{ title: 'Can we leave a phone message on this number?', value: values.PhoneMessagePrompt === 'true' ? 'Yes' : 'No' }] : [],
      values.PhoneApplicant === 'true' ? [{ title: 'Do you need an interpreter to assist?', value: values.InterpreterRequiredPrompt === 'true' ? 'Yes' : 'No' }] : [],
      values.InterpreterRequiredPrompt === 'true' ? [{ title: 'Language', value: values.AlternativeLanguage }] : [],
    ],
  };
  const page16 = {
    title: 'Fineholder’s risk and support details',
    editLink: '/step16',
    fields: [
      [
        {
          title: riskAndSupportDetails.step16.fields.hasScaredFeelings.title,
          value: values.HasScaredFeelings === 'true' ? 'Yes' : 'No',
        },
      ],
      [
        {
          title: riskAndSupportDetails.step16.fields.hasRiskAssessment.title,
          value: values.HasRiskAssessment === 'notKnown' ? "I don't know" : values.HasRiskAssessment === 'true' ? 'Yes' : 'No',
        },
      ],
      [
        {
          title: riskAndSupportDetails.step16.fields.contactSpecialist.title,
          value: values.ContactSpecialist === 'true' ? 'Yes' : 'No',
        },
      ],
    ],
  };
  const page17 = {
    title: 'Fineholder’s background and identity (optional)',
    editLink: '/step17',
    fields: [
      [
        {
          title: backgroundAndIdentityDetails.step17.fields.gender.title,
          value: values.Gender !== '' ? values.Gender.charAt(0).toUpperCase() + values.Gender.split('-').join(' ').slice(1) : 'n/a',
        },
      ],
      values.Gender === 'self-described'
        ? [
            {
              title: backgroundAndIdentityDetails.step17.fields.genderDescription.title,
              value: values.GenderSelfDescribed !== '' ? values.GenderSelfDescribed : 'n/a',
            },
          ]
        : [],
      [
        {
          title: backgroundAndIdentityDetails.step17.fields.lgtiqIdentified.title,
          value: values.LGBTIQIdentified === null ? 'n/a' : values.LGBTIQIdentified === 'true' ? 'Yes' : 'No',
        },
      ],
      [
        {
          title: backgroundAndIdentityDetails.step17.fields.origin.title,
          value: values.Origin !== '' ? values.Origin.charAt(0).toUpperCase() + values.Origin.split('-').join(' ').slice(1) : 'n/a',
        },
      ],
      [
        {
          title: backgroundAndIdentityDetails.step17.fields.englishProficiency.title,
          value: values.EnglishProficiency !== '' ? values.EnglishProficiency.charAt(0).toUpperCase() + values.EnglishProficiency.split('-').join(' ').slice(1) : 'n/a',
        },
      ],
      values.EnglishProficiency === 'not-at-all' || values.EnglishProficiency === 'poorly'
        ? [
            {
              title: backgroundAndIdentityDetails.step17.fields.nativeLanguage.title,
              value: values.NativeLanguage ? values.NativeLanguage : 'n/a',
            },
          ]
        : [],
      values.HasDisability === 'true'
        ? [
            {
              title: backgroundAndIdentityDetails.step17.fields.isDisabled.title,
              value: values.DisabilityDescription !== '' ? `Yes, ${values.DisabilityDescription}` : 'Yes',
            },
          ]
        : [
            {
              title: backgroundAndIdentityDetails.step17.fields.isDisabled.title,
              value: values.HasDisability === null ? 'n/a' : 'No',
            },
          ],
      values.HasDisability !== 'true'
        ? [
            {
              title: backgroundAndIdentityDetails.step17.fields.isDisabled.title,
              value: values.HasDisability !== 'false' ? 'No' : 'n/a',
            },
          ]
        : [],
    ],
  };

  const page18 = {
    title: 'Fines to be included in this application',
    editLink: '/step18',
    fields: [
      [
        {
          title: 'Would you like to add other registered fines to this application?',
          value: values.RegisteredFinesToInclude !== '' ? (values.RegisteredFinesToInclude === 'true' ? 'Yes' : 'No') : 'n/a',
        },
      ],
      values.RegisteredFinesToInclude === 'true'
        ? [
            {
              title: 'Which registered fines would you like to add',
              value: values.AdditionalFinesType,
            },
          ]
        : [],
      values.AdditionalFinesType !== 'All eligible outstanding fines' && values.AdditionalFinesType !== ''
        ? [
            {
              title: 'Other registered fines',
              value: values.obligations.map((fine, index) => values.obligations[index].value).join('\n'),
            },
          ]
        : [],
      [
        {
          title: 'Does the fineholder you have any infringement stage fines that you would like us to consider?',
          value: values.InfringementFinesToInclude !== '' ? (values.InfringementFinesToInclude === 'true' ? 'Yes' : 'No') : 'n/a',
        },
      ],
      values.InfringementFinesToInclude === 'true'
        ? [
            {
              title: 'Other infringement stage fines',
              value: listUnregisteredFines(values, values.AgencyNames).join('\n'),
            },
          ]
        : [],
    ],
  };

  const page19 = {
    title: 'What would you like to happen?',
    editLink: '/step19',
    fields: [] as iSummaryField[][],
  };
  if (values.WhatWouldYouLikeToHappen === 'FinesWithdrawn') page19.fields.push([{ title: 'If application is successful, I wish to:', value: 'Have the fine(s) withdrawn' }]);
  if (values.WhatWouldYouLikeToHappen === 'DriverNominated') {
    page19.fields.push(
      [{ title: 'If application is successful, I wish to:', value: 'Nominate the driver that was in control of the vehicle at the time of the offence(s)' }],
      [{ title: likelyPossibilities.step19.fields.givenNameOptional.title, value: values.GivenNamesOptional !== '' ? values.GivenNamesOptional : 'n/a' }],
      [{ title: likelyPossibilities.step19.fields.familyNameOptional.title, value: values.FamilyNameOptional !== '' ? values.FamilyNameOptional : 'n/a' }],
      [
        {
          title: likelyPossibilities.step19.fields.dateOfBirthOptional.title,
          value: values.DOBOptional ? `${values.DOBOptional.getDate()}/${values.DOBOptional.getMonth() + 1}/${values.DOBOptional.getFullYear()}` : 'n/a',
        },
      ],
      [
        values.NoDriverLicenceOptional
          ? { title: likelyPossibilities.step19.fields.driverLicenceOptional.title, value: 'n/a' }
          : { title: likelyPossibilities.step19.fields.driverLicenceOptional.title, value: values.DriverLicenceNumberOptional !== '' ? values.DriverLicenceNumberOptional : 'n/a' },
      ],
      [
        values.NoDriverLicenceOptional
          ? { title: 'Place of issue', value: 'n/a' }
          : {
              title: 'Place of issue',
              value:
                values.StatecountryOfIssueOptional === 'Australia'
                  ? values.LicenceStateOptional
                    ? values.LicenceStateOptional
                    : 'n/a'
                  : values.StatecountryOfIssueOptional
                  ? values.StatecountryOfIssueOptional
                  : 'n/a',
            },
      ],
    );
  }
  if (values.WhatWouldYouLikeToHappen === 'AboveCombination') {
    page19.fields.push(
      [{ title: 'If application is successful, I wish to:', value: 'A combination of the above' }],
      [{ title: likelyPossibilities.step19.fields.howDealtWithFines.title, value: values.HowDealtWithFines }],
    );
  }
  const page20 = {
    title: 'Payment arrangements',
    editLink: '/step20',
    fields: [
      [
        {
          title: 'Does the fineholder have a payment arrangement with Fines Victoria for any of the fines in this application?',
          value: values.HasPaymentArrangement === 'true' ? 'Yes' : 'No',
        },
      ],
      values.HasPaymentArrangement === 'true'
        ? [
            {
              title: paymentArrangements.step20.fields.removeFines.title,
              value: values.RemoveFines === 'true' ? 'Yes' : 'No',
            },
          ]
        : [],
      values.RemoveFines === 'true'
        ? [
            {
              title: paymentArrangements.step20.fields.reincludeFines.title,
              value: values.ReincludeFines === 'true' ? 'Yes' : 'No',
            },
          ]
        : [],
    ],
  };
  const page21 = {
    title: 'Supporting documents',
    editLink: '/step21',
    fields: [
      [
        {
          title: '',
          value: values.SupportingAttachments.map((attachment) => displayFileDetails(attachment))
            .filter(Boolean)
            .join('\n'),
        },
      ],
      [
        {
          title: '',
          value: values.SignedDeclarationAttachment.map((attachment) => displayFileDetails(attachment))
            .filter(Boolean)
            .join('\n'),
        },
      ],
    ],
  };
  const page22 = {
    title: 'Reasons for application',
    editLink: '/step22',
    fields: [
      [
        {
          title: 'Your reason',
          value: values.ReasonForApplication,
        },
      ],
      [
        {
          title: 'Other supporting documents',
          value: checkOptSupportingDoc !== '' ? checkOptSupportingDoc : 'n/a',
        },
      ],
    ],
  };

  const pagesLodgedByVictim: iSummary[] = [
    page6,
    page7,
    page8,
    page9,
    values.AnyEligibleNomiation || (values.AgencyNames.length >= 1 && values.AgencyNames[0].value !== '') ? page10 : ({} as iSummary),
    values.AnyPaymentArrangement ? page11 : ({} as iSummary),
    page12,
    page13,
  ];
  const pagesLodgedByRepresentative: iSummary[] = [
    page14,
    page15,
    page16,
    page17,
    page18,
    values.AnyEligibleNomiation ||
    (values.obligations.length !== 0 && values.obligations.length >= 1 && values.obligations[0].value !== '') ||
    (values.AgencyNames.length >= 1 && values.AgencyNames[0].value !== '')
      ? page19
      : ({} as iSummary),
    page20,
    page21,
    page22,
  ];
  const summarySections: iSummary[] = [page3, page5, ...(values.ApplicationLodger === 'LodgedByVictim' ? pagesLodgedByVictim : pagesLodgedByRepresentative)];
  return summarySections;
};
